(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cloudsense-modular-hero-oferta"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-carrusel]').forEach(function (root) {
  var viewport = root.querySelector('[data-carrusel-viewport]');
  var slides = Array.prototype.slice.call(root.querySelectorAll('[data-carrusel-slide]'));
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-carrusel-thumb]'));
  var dots = Array.prototype.slice.call(root.querySelectorAll('[data-carrusel-dot]'));
  var prevBtn = root.querySelector('[data-carrusel-prev]');
  var nextBtn = root.querySelector('[data-carrusel-next]');
  if (!viewport || slides.length === 0) return;
  var index = 0;
  var viewportWidth = viewport.getBoundingClientRect().width;

  function positionSlides(deltaPx, withTransition) {
    slides.forEach(function (s, si) {
      var base = (si - index) * viewportWidth;
      s.style.transition = withTransition ? 'transform 0.32s ease' : 'none';
      s.style.transform = 'translateX(' + (base + deltaPx) + 'px)';
    });
  }

  function goTo(i) {
    index = (i + slides.length) % slides.length;
    positionSlides(0, true);
    slides.forEach(function (s, si) {
      if (si === index) {
        s.setAttribute('data-active', '');
      } else {
        s.removeAttribute('data-active');
      }
    });
    thumbs.forEach(function (t, ti) {
      if (ti === index) {
        t.setAttribute('data-active', '');
      } else {
        t.removeAttribute('data-active');
      }
    });
    dots.forEach(function (d, di) {
      if (di === index) {
        d.setAttribute('data-active', '');
      } else {
        d.removeAttribute('data-active');
      }
    });
  }

  if (prevBtn) prevBtn.addEventListener('click', function () { goTo(index - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { goTo(index + 1); });
  thumbs.forEach(function (t, ti) {
    t.addEventListener('click', function () { goTo(ti); });
  });
  dots.forEach(function (d, di) {
    d.addEventListener('click', function () { goTo(di); });
  });

  var dragStartX = null;
  var dragDeltaX = 0;

  viewport.addEventListener('touchstart', function (e) {
    dragStartX = e.touches[0].clientX;
    dragDeltaX = 0;
    viewportWidth = viewport.getBoundingClientRect().width;
  }, { passive: true });

  viewport.addEventListener('touchmove', function (e) {
    if (dragStartX === null) return;
    dragDeltaX = e.touches[0].clientX - dragStartX;
    positionSlides(dragDeltaX, false);
  }, { passive: true });

  viewport.addEventListener('touchend', function () {
    if (dragStartX === null) return;
    var threshold = viewportWidth * 0.18;
    if (Math.abs(dragDeltaX) > threshold && slides.length > 1) {
      goTo(index + (dragDeltaX < 0 ? 1 : -1));
    } else {
      positionSlides(0, true);
    }
    dragStartX = null;
    dragDeltaX = 0;
  });

  window.addEventListener('resize', function () {
    viewportWidth = viewport.getBoundingClientRect().width;
    positionSlides(0, false);
  });

  positionSlides(0, false);
});

/* Ajuste automático de tamaño (ESTRUCTURA.md, reglas de Juanes 28-oct-2026). El copy se escribe
   libre y aquí se ajusta: frase hero en 1 renglón y pregunta de dolor en máximo 2, lo más grandes
   posible sin pasar el tamaño del título. Bullets: el más largo termina en el 75 % del ancho
   (25 % de aire a la derecha) y todos copian ese tamaño. Se recalcula al cargar las fuentes y al
   cambiar el ancho. */
(function () {
  var hero = document.querySelector('.cloudsense-modular-hero-oferta');
  if (!hero) return;
  var titulo = hero.querySelector('.dsx-h1');
  var tagline = hero.querySelector('.cloudsense-modular-tagline');
  var pregunta = hero.querySelector('.cloudsense-modular-pregunta-dolor');
  var bullets = Array.prototype.slice.call(hero.querySelectorAll('.cloudsense-modular-beneficios li'));
  var MINIMO = 9;

  function mayorQueCabe(el, cabe, maximo) {
    var bajo = MINIMO, alto = maximo, mejor = MINIMO;
    for (var i = 0; i < 14; i++) {
      var medio = (bajo + alto) / 2;
      el.style.fontSize = medio + 'px';
      if (cabe(el)) { mejor = medio; bajo = medio; } else { alto = medio; }
    }
    return Math.floor(mejor * 4) / 4;
  }
  var AIRE_BULLETS = 0.25;
  function unRenglon(el) {
    return el.scrollWidth <= el.clientWidth + 1;
  }
  function bulletConAire(li) {
    var disponible = li.parentElement.clientWidth * (1 - AIRE_BULLETS);
    return unRenglon(li) && li.getBoundingClientRect().width <= disponible;
  }
  function dosRenglones(el) {
    el.style.webkitLineClamp = 'unset';
    var cabe = el.scrollHeight <= parseFloat(getComputedStyle(el).fontSize) * 1.5 * 2 + 2;
    el.style.webkitLineClamp = '';
    return cabe;
  }
  function ajustar() {
    var tope = titulo ? parseFloat(getComputedStyle(titulo).fontSize) : 23;
    if (tagline) tagline.style.fontSize = mayorQueCabe(tagline, unRenglon, tope - 1) + 'px';
    if (pregunta) pregunta.style.fontSize = mayorQueCabe(pregunta, dosRenglones, tope - 3) + 'px';
    if (bullets.length) {
      var comun = Math.min.apply(null, bullets.map(function (li) { return mayorQueCabe(li, bulletConAire, 18); }));
      bullets.forEach(function (li) { li.style.fontSize = comun + 'px'; });
    }
  }

  ajustar();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(ajustar);
  var ancho = window.innerWidth;
  var espera;
  window.addEventListener('resize', function () {
    if (window.innerWidth === ancho) return;
    ancho = window.innerWidth;
    clearTimeout(espera);
    espera = setTimeout(ajustar, 150);
  });
})();

/* Estrellas → reseñas con desplazamiento suave, SIN poner "#resenas" en la dirección
   (si quedaba en la dirección, al reabrir el link la página saltaba sola a las reseñas). */
document.querySelectorAll('[data-ir-resenas], [data-ir-seccion]').forEach(function (enlace) {
  enlace.addEventListener('click', function (e) {
    var destino = document.getElementById(enlace.getAttribute('data-ir-seccion') || 'resenas');
    if (!destino) return;
    e.preventDefault();
    var y = destino.getBoundingClientRect().top + window.pageYOffset;
    var desde = window.pageYOffset;
    window.scrollTo({ top: y, behavior: 'smooth' });
    // Respaldo: si el navegador no anima (pestaña en segundo plano, ahorro de batería), salta directo.
    setTimeout(function () {
      if (Math.abs(window.pageYOffset - desde) < 5) window.scrollTo(0, y);
    }, 700);
  });
});

/* Botón de compra → formulario contra entrega de Releasit (ESTRUCTURA.md, "Conexión con Releasit").
   Esta plantilla no tiene formulario de producto, así que Releasit no inserta su botón: el único
   que crea queda oculto dentro de su botón flotante (desactivado). Nuestro botón dispara ese botón
   oculto, que es el que abre el formulario. Si Releasit todavía no cargó, se espera hasta 3 s; si no
   está (desinstalado o caído), se usa el enlace de carrito de Shopify para no perder la venta.
   Si el botón ya trae data-abrir-selcombo (producto con selector de combo propio), este bloque no
   hace nada: el popup del selector de combo (sección aparte) ya lo resuelve. {% javascript %} es JS
   puro, sin Liquid, así que la rama se decide en runtime por el atributo del botón, no con {% if %}. */
(function () {
  var principal = document.querySelector('.cloudsense-modular-btn-buy');
  if (!principal || principal.hasAttribute('data-abrir-selcombo')) return;
  function botonReleasit() {
    return document.getElementById('_rsi-buy-now-button') || document.querySelector('._rsi-buy-now-button');
  }
  principal.addEventListener('click', function () {
    var inicio = Date.now();
    (function intentar() {
      var rsi = botonReleasit();
      if (rsi) { rsi.click(); return; }
      if (Date.now() - inicio < 3000) { setTimeout(intentar, 150); return; }
      var variante = principal.getAttribute('data-variante');
      if (variante) window.location.href = '/cart/' + variante + ':1';
    })();
  });
})();

/* Botón de compra fijo: aparece cuando el botón principal ya quedó arriba, fuera de la pantalla,
   y se esconde cuando el cliente vuelve a verlo. Tocarlo es tocar el botón principal. */
(function () {
  var principal = document.querySelector('.cloudsense-modular-btn-buy');
  var barra = document.querySelector('[data-sticky-cta]');
  if (!principal || !barra || !('IntersectionObserver' in window)) return;
  var boton = barra.querySelector('button');
  boton.addEventListener('click', function () { principal.click(); });
  new IntersectionObserver(function (entradas) {
    var e = entradas[0];
    var mostrar = !e.isIntersecting && e.boundingClientRect.top < 0;
    // En la vista previa de Shopify su barra inferior tapa el botón; se sube encima de ella.
    // Los clientes no tienen esa barra, así que para ellos no cambia nada.
    var barraPreview = document.getElementById('PBarNextFrameWrapper');
    barra.style.bottom = barraPreview ? barraPreview.getBoundingClientRect().height + 'px' : '';
    barra.classList.toggle('is-visible', mostrar);
    barra.setAttribute('aria-hidden', mostrar ? 'false' : 'true');
    boton.tabIndex = mostrar ? 0 : -1;
  }).observe(principal);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cloudsense-modular-resenas"] && !Shopify.designMode) return;
  try {
    
var DSX_CO_DEPARTAMENTOS = {
  "Amazonas": ["Leticia", "Puerto Nariño"],
  "Antioquia": ["Medellín", "Bello", "Itagüí", "Envigado", "Rionegro", "Apartadó"],
  "Arauca": ["Arauca", "Saravena", "Tame"],
  "Atlántico": ["Barranquilla", "Soledad", "Malambo", "Puerto Colombia"],
  "Bogotá D.C.": ["Bogotá"],
  "Bolívar": ["Cartagena", "Magangué", "Turbaco"],
  "Boyacá": ["Tunja", "Duitama", "Sogamoso", "Chiquinquirá"],
  "Caldas": ["Manizales", "La Dorada", "Chinchiná"],
  "Caquetá": ["Florencia", "San Vicente del Caguán"],
  "Casanare": ["Yopal", "Aguazul"],
  "Cauca": ["Popayán", "Santander de Quilichao"],
  "Cesar": ["Valledupar", "Aguachica"],
  "Chocó": ["Quibdó", "Istmina"],
  "Córdoba": ["Montería", "Cereté", "Lorica"],
  "Cundinamarca": ["Soacha", "Zipaquirá", "Chía", "Facatativá", "Girardot"],
  "Guainía": ["Inírida"],
  "Guaviare": ["San José del Guaviare"],
  "Huila": ["Neiva", "Pitalito", "Garzón"],
  "La Guajira": ["Riohacha", "Maicao"],
  "Magdalena": ["Santa Marta", "Ciénaga"],
  "Meta": ["Villavicencio", "Acacías", "Granada"],
  "Nariño": ["Pasto", "Ipiales", "Tumaco"],
  "Norte de Santander": ["Cúcuta", "Ocaña", "Pamplona"],
  "Putumayo": ["Mocoa", "Puerto Asís"],
  "Quindío": ["Armenia", "Calarcá"],
  "Risaralda": ["Pereira", "Dosquebradas", "Santa Rosa de Cabal"],
  "San Andrés y Providencia": ["San Andrés", "Providencia"],
  "Santander": ["Bucaramanga", "Floridablanca", "Girón", "Piedecuesta", "Barrancabermeja"],
  "Sucre": ["Sincelejo", "Corozal"],
  "Tolima": ["Ibagué", "Espinal", "Melgar"],
  "Valle del Cauca": ["Cali", "Palmira", "Buenaventura", "Tuluá", "Buga"],
  "Vaupés": ["Mitú"],
  "Vichada": ["Puerto Carreño"]
};

document.querySelectorAll('[data-resenas-seccion]').forEach(function (seccion) {
  var productId = seccion.getAttribute('data-producto-id') || 'default';
  var storageKey = 'dsx_resena_propia_' + productId;
  var lista = seccion.querySelector('[data-resenas-lista]');
  var abrirBtn = seccion.querySelector('[data-resenas-abrir]');
  var dialog = seccion.querySelector('[data-resenas-dialog]');
  var cerrarBtn = seccion.querySelector('[data-resenas-cerrar]');
  var form = seccion.querySelector('[data-resenas-form]');
  var nombreInput = seccion.querySelector('[data-resenas-nombre]');
  var textoInput = seccion.querySelector('[data-resenas-texto]');
  var avatarInput = seccion.querySelector('[data-resenas-avatar-input]');
  var fotoInput = seccion.querySelector('[data-resenas-foto-input]');
  var avatarBotonTexto = seccion.querySelector('[data-resenas-avatar-boton]');
  var fotoBotonTexto = seccion.querySelector('[data-resenas-foto-boton]');
  var depSelect = seccion.querySelector('[data-resenas-departamento]');
  var ciuSelect = seccion.querySelector('[data-resenas-ciudad]');
  var estrellaBtns = Array.prototype.slice.call(seccion.querySelectorAll('[data-estrella]'));
  var estrellasValor = 5;
  var datosActuales = null;
  var tarjetaInsertada = null;

  function getClass(sufijo) {
    return 'cloudsense-modular-resenas__' + sufijo;
  }

  function poblarDepartamentos() {
    if (!depSelect) return;
    Object.keys(DSX_CO_DEPARTAMENTOS).sort().forEach(function (dep) {
      var opt = document.createElement('option');
      opt.value = dep;
      opt.textContent = dep;
      depSelect.appendChild(opt);
    });
  }
  function poblarCiudades(dep) {
    if (!ciuSelect) return;
    ciuSelect.innerHTML = '<option value="">Ciudad</option>';
    (DSX_CO_DEPARTAMENTOS[dep] || []).forEach(function (c) {
      var opt = document.createElement('option');
      opt.value = c;
      opt.textContent = c;
      ciuSelect.appendChild(opt);
    });
    ciuSelect.disabled = !dep;
  }
  if (depSelect) {
    poblarDepartamentos();
    depSelect.addEventListener('change', function () {
      poblarCiudades(depSelect.value);
    });
  }

  function cerrarDialogo() {
    if (dialog.close) { dialog.close(); } else { dialog.removeAttribute('open'); }
  }

  function pintarEstrellas(n) {
    estrellaBtns.forEach(function (b) {
      var v = parseInt(b.getAttribute('data-estrella'), 10);
      var svg = b.querySelector('svg');
      if (svg) svg.setAttribute('fill', v <= n ? '#F5A623' : '#E5E7EB');
    });
  }
  estrellaBtns.forEach(function (b) {
    b.addEventListener('click', function () {
      estrellasValor = parseInt(b.getAttribute('data-estrella'), 10);
      pintarEstrellas(estrellasValor);
    });
  });

  if (avatarInput && avatarBotonTexto) {
    avatarInput.addEventListener('change', function () {
      avatarBotonTexto.textContent = avatarInput.files.length ? 'Foto lista ✓' : 'Elegir foto';
    });
  }
  if (fotoInput && fotoBotonTexto) {
    fotoInput.addEventListener('change', function () {
      fotoBotonTexto.textContent = fotoInput.files.length ? 'Foto lista ✓' : 'Elegir foto';
    });
  }

  function leerImagenComoDataURL(file, maxDim, calidad, callback) {
    if (!file) { callback(null); return; }
    var lector = new FileReader();
    lector.onload = function (ev) {
      var img = new Image();
      img.onload = function () {
        var escala = Math.min(1, maxDim / Math.max(img.width, img.height));
        var cw = Math.max(1, Math.round(img.width * escala));
        var ch = Math.max(1, Math.round(img.height * escala));
        var canvas = document.createElement('canvas');
        canvas.width = cw;
        canvas.height = ch;
        var ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, cw, ch);
        try {
          callback(canvas.toDataURL('image/jpeg', calidad));
        } catch (err) {
          callback(null);
        }
      };
      img.onerror = function () { callback(null); };
      img.src = ev.target.result;
    };
    lector.onerror = function () { callback(null); };
    lector.readAsDataURL(file);
  }

  function construirTarjetaPropia(data) {
    var card = document.createElement('div');
    card.setAttribute('class', getClass('card'));

    var estrellasDiv = document.createElement('div');
    estrellasDiv.setAttribute('class', getClass('estrellas'));
    for (var i = 1; i <= 5; i++) {
      var color = i <= data.estrellas ? '#F5A623' : '#E5E7EB';
      estrellasDiv.insertAdjacentHTML('beforeend', '<svg width="16" height="16" viewBox="0 0 24 24" fill="' + color + '" aria-hidden="true"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26"></polygon></svg>');
    }
    card.appendChild(estrellasDiv);

    var autor = document.createElement('div');
    autor.setAttribute('class', getClass('autor'));

    var avatar = document.createElement('span');
    avatar.setAttribute('class', getClass('avatar'));
    if (data.avatar) {
      var avatarImg = document.createElement('img');
      avatarImg.src = data.avatar;
      avatarImg.alt = '';
      avatar.appendChild(avatarImg);
    } else {
      avatar.textContent = (data.nombre || '?').slice(0, 1);
    }
    autor.appendChild(avatar);

    var autorTexto = document.createElement('div');
    autorTexto.setAttribute('class', getClass('autor-texto'));
    var nombreLinea = document.createElement('div');
    nombreLinea.setAttribute('class', getClass('nombre-linea'));
    var nombreSpan = document.createElement('span');
    nombreSpan.setAttribute('class', getClass('nombre'));
    nombreSpan.textContent = data.nombre;
    nombreLinea.appendChild(nombreSpan);

    var pendiente = document.createElement('span');
    pendiente.setAttribute('class', getClass('verificada') + ' ' + getClass('verificada--pendiente'));
    pendiente.innerHTML = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#D97706" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"></polyline></svg>En verificación';
    nombreLinea.appendChild(pendiente);

    autorTexto.appendChild(nombreLinea);

    if (data.ciudad) {
      var ciudadP = document.createElement('p');
      ciudadP.setAttribute('class', getClass('ciudad'));
      ciudadP.textContent = data.ciudad;
      autorTexto.appendChild(ciudadP);
    }

    autor.appendChild(autorTexto);
    card.appendChild(autor);

    var texto = document.createElement('p');
    texto.setAttribute('class', getClass('texto'));
    texto.textContent = data.texto;
    card.appendChild(texto);

    if (data.foto) {
      var fotoImg = document.createElement('img');
      fotoImg.setAttribute('class', getClass('foto-adjunta'));
      fotoImg.src = data.foto;
      fotoImg.alt = '';
      card.appendChild(fotoImg);
    }

    return card;
  }

  function mostrarPropia(data) {
    datosActuales = data;
    if (!lista) return;
    if (!tarjetaInsertada) {
      tarjetaInsertada = construirTarjetaPropia(data);
      lista.insertBefore(tarjetaInsertada, lista.firstChild);
    } else {
      var nueva = construirTarjetaPropia(data);
      tarjetaInsertada.replaceWith(nueva);
      tarjetaInsertada = nueva;
    }
    if (abrirBtn) abrirBtn.textContent = 'Editar tu reseña';
  }

  function leerGuardada() {
    try {
      var raw = window.localStorage.getItem(storageKey);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }
  function guardar(data) {
    try {
      window.localStorage.setItem(storageKey, JSON.stringify(data));
    } catch (e) {}
  }

  if (abrirBtn) {
    abrirBtn.addEventListener('click', function () {
      if (datosActuales) {
        nombreInput.value = datosActuales.nombre;
        textoInput.value = datosActuales.texto;
        estrellasValor = datosActuales.estrellas;
        pintarEstrellas(estrellasValor);
        if (avatarBotonTexto) avatarBotonTexto.textContent = datosActuales.avatar ? 'Foto lista ✓' : 'Elegir foto';
        if (fotoBotonTexto) fotoBotonTexto.textContent = datosActuales.foto ? 'Foto lista ✓' : 'Elegir foto';
        if (depSelect && datosActuales.departamento) {
          depSelect.value = datosActuales.departamento;
          poblarCiudades(datosActuales.departamento);
          if (ciuSelect && datosActuales.ciudad) ciuSelect.value = datosActuales.ciudad;
        }
      }
      if (dialog.showModal) { dialog.showModal(); } else { dialog.setAttribute('open', ''); }
    });
  }
  if (cerrarBtn) cerrarBtn.addEventListener('click', cerrarDialogo);
  dialog.addEventListener('click', function (e) {
    if (e.target === dialog) cerrarDialogo();
  });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var nombre = nombreInput.value.trim();
    var texto = textoInput.value.trim();
    if (!nombre || !texto) return;
    var avatarFile = avatarInput && avatarInput.files && avatarInput.files[0];
    var fotoFile = fotoInput && fotoInput.files && fotoInput.files[0];
    leerImagenComoDataURL(avatarFile, 200, 0.82, function (avatarData) {
      leerImagenComoDataURL(fotoFile, 720, 0.78, function (fotoData) {
        var data = {
          nombre: nombre,
          texto: texto,
          estrellas: estrellasValor,
          departamento: depSelect ? depSelect.value : '',
          ciudad: ciuSelect ? ciuSelect.value : '',
          avatar: avatarData || (datosActuales && datosActuales.avatar) || null,
          foto: fotoData || (datosActuales && datosActuales.foto) || null
        };
        guardar(data);
        mostrarPropia(data);
        cerrarDialogo();
      });
    });
  });

  var guardada = leerGuardada();
  if (guardada) {
    mostrarPropia(guardada);
  } else {
    pintarEstrellas(estrellasValor);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fundas-navidenas-modular-hero-oferta"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-carrusel]').forEach(function (root) {
  var viewport = root.querySelector('[data-carrusel-viewport]');
  var slides = Array.prototype.slice.call(root.querySelectorAll('[data-carrusel-slide]'));
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-carrusel-thumb]'));
  var dots = Array.prototype.slice.call(root.querySelectorAll('[data-carrusel-dot]'));
  var prevBtn = root.querySelector('[data-carrusel-prev]');
  var nextBtn = root.querySelector('[data-carrusel-next]');
  if (!viewport || slides.length === 0) return;
  var index = 0;
  var viewportWidth = viewport.getBoundingClientRect().width;

  function positionSlides(deltaPx, withTransition) {
    slides.forEach(function (s, si) {
      var base = (si - index) * viewportWidth;
      s.style.transition = withTransition ? 'transform 0.32s ease' : 'none';
      s.style.transform = 'translateX(' + (base + deltaPx) + 'px)';
    });
  }

  function goTo(i) {
    index = (i + slides.length) % slides.length;
    positionSlides(0, true);
    slides.forEach(function (s, si) {
      if (si === index) {
        s.setAttribute('data-active', '');
      } else {
        s.removeAttribute('data-active');
      }
    });
    thumbs.forEach(function (t, ti) {
      if (ti === index) {
        t.setAttribute('data-active', '');
      } else {
        t.removeAttribute('data-active');
      }
    });
    dots.forEach(function (d, di) {
      if (di === index) {
        d.setAttribute('data-active', '');
      } else {
        d.removeAttribute('data-active');
      }
    });
  }

  if (prevBtn) prevBtn.addEventListener('click', function () { goTo(index - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { goTo(index + 1); });
  thumbs.forEach(function (t, ti) {
    t.addEventListener('click', function () { goTo(ti); });
  });
  dots.forEach(function (d, di) {
    d.addEventListener('click', function () { goTo(di); });
  });

  var dragStartX = null;
  var dragDeltaX = 0;

  viewport.addEventListener('touchstart', function (e) {
    dragStartX = e.touches[0].clientX;
    dragDeltaX = 0;
    viewportWidth = viewport.getBoundingClientRect().width;
  }, { passive: true });

  viewport.addEventListener('touchmove', function (e) {
    if (dragStartX === null) return;
    dragDeltaX = e.touches[0].clientX - dragStartX;
    positionSlides(dragDeltaX, false);
  }, { passive: true });

  viewport.addEventListener('touchend', function () {
    if (dragStartX === null) return;
    var threshold = viewportWidth * 0.18;
    if (Math.abs(dragDeltaX) > threshold && slides.length > 1) {
      goTo(index + (dragDeltaX < 0 ? 1 : -1));
    } else {
      positionSlides(0, true);
    }
    dragStartX = null;
    dragDeltaX = 0;
  });

  window.addEventListener('resize', function () {
    viewportWidth = viewport.getBoundingClientRect().width;
    positionSlides(0, false);
  });

  positionSlides(0, false);
});

/* Ajuste automático de tamaño (ESTRUCTURA.md, reglas de Juanes 28-oct-2026). El copy se escribe
   libre y aquí se ajusta: frase hero en 1 renglón y pregunta de dolor en máximo 2, lo más grandes
   posible sin pasar el tamaño del título. Bullets: el más largo termina en el 75 % del ancho
   (25 % de aire a la derecha) y todos copian ese tamaño. Se recalcula al cargar las fuentes y al
   cambiar el ancho. */
(function () {
  var hero = document.querySelector('.fundas-navidenas-modular-hero-oferta');
  if (!hero) return;
  var titulo = hero.querySelector('.dsx-h1');
  var tagline = hero.querySelector('.fundas-navidenas-modular-tagline');
  var pregunta = hero.querySelector('.fundas-navidenas-modular-pregunta-dolor');
  var bullets = Array.prototype.slice.call(hero.querySelectorAll('.fundas-navidenas-modular-beneficios li'));
  var MINIMO = 9;

  function mayorQueCabe(el, cabe, maximo) {
    var bajo = MINIMO, alto = maximo, mejor = MINIMO;
    for (var i = 0; i < 14; i++) {
      var medio = (bajo + alto) / 2;
      el.style.fontSize = medio + 'px';
      if (cabe(el)) { mejor = medio; bajo = medio; } else { alto = medio; }
    }
    return Math.floor(mejor * 4) / 4;
  }
  var AIRE_BULLETS = 0.25;
  function unRenglon(el) {
    return el.scrollWidth <= el.clientWidth + 1;
  }
  function bulletConAire(li) {
    var disponible = li.parentElement.clientWidth * (1 - AIRE_BULLETS);
    return unRenglon(li) && li.getBoundingClientRect().width <= disponible;
  }
  function dosRenglones(el) {
    el.style.webkitLineClamp = 'unset';
    var cabe = el.scrollHeight <= parseFloat(getComputedStyle(el).fontSize) * 1.5 * 2 + 2;
    el.style.webkitLineClamp = '';
    return cabe;
  }
  function ajustar() {
    var tope = titulo ? parseFloat(getComputedStyle(titulo).fontSize) : 23;
    if (tagline) tagline.style.fontSize = mayorQueCabe(tagline, unRenglon, tope - 1) + 'px';
    if (pregunta) pregunta.style.fontSize = mayorQueCabe(pregunta, dosRenglones, tope - 3) + 'px';
    if (bullets.length) {
      var comun = Math.min.apply(null, bullets.map(function (li) { return mayorQueCabe(li, bulletConAire, 18); }));
      bullets.forEach(function (li) { li.style.fontSize = comun + 'px'; });
    }
  }

  ajustar();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(ajustar);
  var ancho = window.innerWidth;
  var espera;
  window.addEventListener('resize', function () {
    if (window.innerWidth === ancho) return;
    ancho = window.innerWidth;
    clearTimeout(espera);
    espera = setTimeout(ajustar, 150);
  });
})();

/* Estrellas → reseñas con desplazamiento suave, SIN poner "#resenas" en la dirección
   (si quedaba en la dirección, al reabrir el link la página saltaba sola a las reseñas). */
document.querySelectorAll('[data-ir-resenas], [data-ir-seccion]').forEach(function (enlace) {
  enlace.addEventListener('click', function (e) {
    var destino = document.getElementById(enlace.getAttribute('data-ir-seccion') || 'resenas');
    if (!destino) return;
    e.preventDefault();
    var y = destino.getBoundingClientRect().top + window.pageYOffset;
    var desde = window.pageYOffset;
    window.scrollTo({ top: y, behavior: 'smooth' });
    // Respaldo: si el navegador no anima (pestaña en segundo plano, ahorro de batería), salta directo.
    setTimeout(function () {
      if (Math.abs(window.pageYOffset - desde) < 5) window.scrollTo(0, y);
    }, 700);
  });
});

/* Botón de compra → formulario contra entrega de Releasit (ESTRUCTURA.md, "Conexión con Releasit").
   Esta plantilla no tiene formulario de producto, así que Releasit no inserta su botón: el único
   que crea queda oculto dentro de su botón flotante (desactivado). Nuestro botón dispara ese botón
   oculto, que es el que abre el formulario. Si Releasit todavía no cargó, se espera hasta 3 s; si no
   está (desinstalado o caído), se usa el enlace de carrito de Shopify para no perder la venta.
   Si el botón ya trae data-abrir-selcombo (producto con selector de combo propio), este bloque no
   hace nada: el popup del selector de combo (sección aparte) ya lo resuelve. {% javascript %} es JS
   puro, sin Liquid, así que la rama se decide en runtime por el atributo del botón, no con {% if %}. */
(function () {
  var principal = document.querySelector('.fundas-navidenas-modular-btn-buy');
  if (!principal || principal.hasAttribute('data-abrir-selcombo')) return;
  function botonReleasit() {
    return document.getElementById('_rsi-buy-now-button') || document.querySelector('._rsi-buy-now-button');
  }
  principal.addEventListener('click', function () {
    var inicio = Date.now();
    (function intentar() {
      var rsi = botonReleasit();
      if (rsi) { rsi.click(); return; }
      if (Date.now() - inicio < 3000) { setTimeout(intentar, 150); return; }
      var variante = principal.getAttribute('data-variante');
      if (variante) window.location.href = '/cart/' + variante + ':1';
    })();
  });
})();

/* Botón de compra fijo: aparece cuando el botón principal ya quedó arriba, fuera de la pantalla,
   y se esconde cuando el cliente vuelve a verlo. Tocarlo es tocar el botón principal. */
(function () {
  var principal = document.querySelector('.fundas-navidenas-modular-btn-buy');
  var barra = document.querySelector('[data-sticky-cta]');
  if (!principal || !barra || !('IntersectionObserver' in window)) return;
  var boton = barra.querySelector('button');
  boton.addEventListener('click', function () { principal.click(); });
  new IntersectionObserver(function (entradas) {
    var e = entradas[0];
    var mostrar = !e.isIntersecting && e.boundingClientRect.top < 0;
    // En la vista previa de Shopify su barra inferior tapa el botón; se sube encima de ella.
    // Los clientes no tienen esa barra, así que para ellos no cambia nada.
    var barraPreview = document.getElementById('PBarNextFrameWrapper');
    barra.style.bottom = barraPreview ? barraPreview.getBoundingClientRect().height + 'px' : '';
    barra.classList.toggle('is-visible', mostrar);
    barra.setAttribute('aria-hidden', mostrar ? 'false' : 'true');
    boton.tabIndex = mostrar ? 0 : -1;
  }).observe(principal);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fundas-navidenas-modular-resenas"] && !Shopify.designMode) return;
  try {
    
var DSX_CO_DEPARTAMENTOS = {
  "Amazonas": ["Leticia", "Puerto Nariño"],
  "Antioquia": ["Medellín", "Bello", "Itagüí", "Envigado", "Rionegro", "Apartadó"],
  "Arauca": ["Arauca", "Saravena", "Tame"],
  "Atlántico": ["Barranquilla", "Soledad", "Malambo", "Puerto Colombia"],
  "Bogotá D.C.": ["Bogotá"],
  "Bolívar": ["Cartagena", "Magangué", "Turbaco"],
  "Boyacá": ["Tunja", "Duitama", "Sogamoso", "Chiquinquirá"],
  "Caldas": ["Manizales", "La Dorada", "Chinchiná"],
  "Caquetá": ["Florencia", "San Vicente del Caguán"],
  "Casanare": ["Yopal", "Aguazul"],
  "Cauca": ["Popayán", "Santander de Quilichao"],
  "Cesar": ["Valledupar", "Aguachica"],
  "Chocó": ["Quibdó", "Istmina"],
  "Córdoba": ["Montería", "Cereté", "Lorica"],
  "Cundinamarca": ["Soacha", "Zipaquirá", "Chía", "Facatativá", "Girardot"],
  "Guainía": ["Inírida"],
  "Guaviare": ["San José del Guaviare"],
  "Huila": ["Neiva", "Pitalito", "Garzón"],
  "La Guajira": ["Riohacha", "Maicao"],
  "Magdalena": ["Santa Marta", "Ciénaga"],
  "Meta": ["Villavicencio", "Acacías", "Granada"],
  "Nariño": ["Pasto", "Ipiales", "Tumaco"],
  "Norte de Santander": ["Cúcuta", "Ocaña", "Pamplona"],
  "Putumayo": ["Mocoa", "Puerto Asís"],
  "Quindío": ["Armenia", "Calarcá"],
  "Risaralda": ["Pereira", "Dosquebradas", "Santa Rosa de Cabal"],
  "San Andrés y Providencia": ["San Andrés", "Providencia"],
  "Santander": ["Bucaramanga", "Floridablanca", "Girón", "Piedecuesta", "Barrancabermeja"],
  "Sucre": ["Sincelejo", "Corozal"],
  "Tolima": ["Ibagué", "Espinal", "Melgar"],
  "Valle del Cauca": ["Cali", "Palmira", "Buenaventura", "Tuluá", "Buga"],
  "Vaupés": ["Mitú"],
  "Vichada": ["Puerto Carreño"]
};

document.querySelectorAll('[data-resenas-seccion]').forEach(function (seccion) {
  var productId = seccion.getAttribute('data-producto-id') || 'default';
  var storageKey = 'dsx_resena_propia_' + productId;
  var lista = seccion.querySelector('[data-resenas-lista]');
  var abrirBtn = seccion.querySelector('[data-resenas-abrir]');
  var dialog = seccion.querySelector('[data-resenas-dialog]');
  var cerrarBtn = seccion.querySelector('[data-resenas-cerrar]');
  var form = seccion.querySelector('[data-resenas-form]');
  var nombreInput = seccion.querySelector('[data-resenas-nombre]');
  var textoInput = seccion.querySelector('[data-resenas-texto]');
  var avatarInput = seccion.querySelector('[data-resenas-avatar-input]');
  var fotoInput = seccion.querySelector('[data-resenas-foto-input]');
  var avatarBotonTexto = seccion.querySelector('[data-resenas-avatar-boton]');
  var fotoBotonTexto = seccion.querySelector('[data-resenas-foto-boton]');
  var depSelect = seccion.querySelector('[data-resenas-departamento]');
  var ciuSelect = seccion.querySelector('[data-resenas-ciudad]');
  var estrellaBtns = Array.prototype.slice.call(seccion.querySelectorAll('[data-estrella]'));
  var estrellasValor = 5;
  var datosActuales = null;
  var tarjetaInsertada = null;

  function getClass(sufijo) {
    return 'fundas-navidenas-modular-resenas__' + sufijo;
  }

  function poblarDepartamentos() {
    if (!depSelect) return;
    Object.keys(DSX_CO_DEPARTAMENTOS).sort().forEach(function (dep) {
      var opt = document.createElement('option');
      opt.value = dep;
      opt.textContent = dep;
      depSelect.appendChild(opt);
    });
  }
  function poblarCiudades(dep) {
    if (!ciuSelect) return;
    ciuSelect.innerHTML = '<option value="">Ciudad</option>';
    (DSX_CO_DEPARTAMENTOS[dep] || []).forEach(function (c) {
      var opt = document.createElement('option');
      opt.value = c;
      opt.textContent = c;
      ciuSelect.appendChild(opt);
    });
    ciuSelect.disabled = !dep;
  }
  if (depSelect) {
    poblarDepartamentos();
    depSelect.addEventListener('change', function () {
      poblarCiudades(depSelect.value);
    });
  }

  function cerrarDialogo() {
    if (dialog.close) { dialog.close(); } else { dialog.removeAttribute('open'); }
  }

  function pintarEstrellas(n) {
    estrellaBtns.forEach(function (b) {
      var v = parseInt(b.getAttribute('data-estrella'), 10);
      var svg = b.querySelector('svg');
      if (svg) svg.setAttribute('fill', v <= n ? '#F5A623' : '#E5E7EB');
    });
  }
  estrellaBtns.forEach(function (b) {
    b.addEventListener('click', function () {
      estrellasValor = parseInt(b.getAttribute('data-estrella'), 10);
      pintarEstrellas(estrellasValor);
    });
  });

  if (avatarInput && avatarBotonTexto) {
    avatarInput.addEventListener('change', function () {
      avatarBotonTexto.textContent = avatarInput.files.length ? 'Foto lista ✓' : 'Elegir foto';
    });
  }
  if (fotoInput && fotoBotonTexto) {
    fotoInput.addEventListener('change', function () {
      fotoBotonTexto.textContent = fotoInput.files.length ? 'Foto lista ✓' : 'Elegir foto';
    });
  }

  function leerImagenComoDataURL(file, maxDim, calidad, callback) {
    if (!file) { callback(null); return; }
    var lector = new FileReader();
    lector.onload = function (ev) {
      var img = new Image();
      img.onload = function () {
        var escala = Math.min(1, maxDim / Math.max(img.width, img.height));
        var cw = Math.max(1, Math.round(img.width * escala));
        var ch = Math.max(1, Math.round(img.height * escala));
        var canvas = document.createElement('canvas');
        canvas.width = cw;
        canvas.height = ch;
        var ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, cw, ch);
        try {
          callback(canvas.toDataURL('image/jpeg', calidad));
        } catch (err) {
          callback(null);
        }
      };
      img.onerror = function () { callback(null); };
      img.src = ev.target.result;
    };
    lector.onerror = function () { callback(null); };
    lector.readAsDataURL(file);
  }

  function construirTarjetaPropia(data) {
    var card = document.createElement('div');
    card.setAttribute('class', getClass('card'));

    var estrellasDiv = document.createElement('div');
    estrellasDiv.setAttribute('class', getClass('estrellas'));
    for (var i = 1; i <= 5; i++) {
      var color = i <= data.estrellas ? '#F5A623' : '#E5E7EB';
      estrellasDiv.insertAdjacentHTML('beforeend', '<svg width="16" height="16" viewBox="0 0 24 24" fill="' + color + '" aria-hidden="true"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26"></polygon></svg>');
    }
    card.appendChild(estrellasDiv);

    var autor = document.createElement('div');
    autor.setAttribute('class', getClass('autor'));

    var avatar = document.createElement('span');
    avatar.setAttribute('class', getClass('avatar'));
    if (data.avatar) {
      var avatarImg = document.createElement('img');
      avatarImg.src = data.avatar;
      avatarImg.alt = '';
      avatar.appendChild(avatarImg);
    } else {
      avatar.textContent = (data.nombre || '?').slice(0, 1);
    }
    autor.appendChild(avatar);

    var autorTexto = document.createElement('div');
    autorTexto.setAttribute('class', getClass('autor-texto'));
    var nombreLinea = document.createElement('div');
    nombreLinea.setAttribute('class', getClass('nombre-linea'));
    var nombreSpan = document.createElement('span');
    nombreSpan.setAttribute('class', getClass('nombre'));
    nombreSpan.textContent = data.nombre;
    nombreLinea.appendChild(nombreSpan);

    var pendiente = document.createElement('span');
    pendiente.setAttribute('class', getClass('verificada') + ' ' + getClass('verificada--pendiente'));
    pendiente.innerHTML = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#D97706" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"></polyline></svg>En verificación';
    nombreLinea.appendChild(pendiente);

    autorTexto.appendChild(nombreLinea);

    if (data.ciudad) {
      var ciudadP = document.createElement('p');
      ciudadP.setAttribute('class', getClass('ciudad'));
      ciudadP.textContent = data.ciudad;
      autorTexto.appendChild(ciudadP);
    }

    autor.appendChild(autorTexto);
    card.appendChild(autor);

    var texto = document.createElement('p');
    texto.setAttribute('class', getClass('texto'));
    texto.textContent = data.texto;
    card.appendChild(texto);

    if (data.foto) {
      var fotoImg = document.createElement('img');
      fotoImg.setAttribute('class', getClass('foto-adjunta'));
      fotoImg.src = data.foto;
      fotoImg.alt = '';
      card.appendChild(fotoImg);
    }

    return card;
  }

  function mostrarPropia(data) {
    datosActuales = data;
    if (!lista) return;
    if (!tarjetaInsertada) {
      tarjetaInsertada = construirTarjetaPropia(data);
      lista.insertBefore(tarjetaInsertada, lista.firstChild);
    } else {
      var nueva = construirTarjetaPropia(data);
      tarjetaInsertada.replaceWith(nueva);
      tarjetaInsertada = nueva;
    }
    if (abrirBtn) abrirBtn.textContent = 'Editar tu reseña';
  }

  function leerGuardada() {
    try {
      var raw = window.localStorage.getItem(storageKey);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }
  function guardar(data) {
    try {
      window.localStorage.setItem(storageKey, JSON.stringify(data));
    } catch (e) {}
  }

  if (abrirBtn) {
    abrirBtn.addEventListener('click', function () {
      if (datosActuales) {
        nombreInput.value = datosActuales.nombre;
        textoInput.value = datosActuales.texto;
        estrellasValor = datosActuales.estrellas;
        pintarEstrellas(estrellasValor);
        if (avatarBotonTexto) avatarBotonTexto.textContent = datosActuales.avatar ? 'Foto lista ✓' : 'Elegir foto';
        if (fotoBotonTexto) fotoBotonTexto.textContent = datosActuales.foto ? 'Foto lista ✓' : 'Elegir foto';
        if (depSelect && datosActuales.departamento) {
          depSelect.value = datosActuales.departamento;
          poblarCiudades(datosActuales.departamento);
          if (ciuSelect && datosActuales.ciudad) ciuSelect.value = datosActuales.ciudad;
        }
      }
      if (dialog.showModal) { dialog.showModal(); } else { dialog.setAttribute('open', ''); }
    });
  }
  if (cerrarBtn) cerrarBtn.addEventListener('click', cerrarDialogo);
  dialog.addEventListener('click', function (e) {
    if (e.target === dialog) cerrarDialogo();
  });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var nombre = nombreInput.value.trim();
    var texto = textoInput.value.trim();
    if (!nombre || !texto) return;
    var avatarFile = avatarInput && avatarInput.files && avatarInput.files[0];
    var fotoFile = fotoInput && fotoInput.files && fotoInput.files[0];
    leerImagenComoDataURL(avatarFile, 200, 0.82, function (avatarData) {
      leerImagenComoDataURL(fotoFile, 720, 0.78, function (fotoData) {
        var data = {
          nombre: nombre,
          texto: texto,
          estrellas: estrellasValor,
          departamento: depSelect ? depSelect.value : '',
          ciudad: ciuSelect ? ciuSelect.value : '',
          avatar: avatarData || (datosActuales && datosActuales.avatar) || null,
          foto: fotoData || (datosActuales && datosActuales.foto) || null
        };
        guardar(data);
        mostrarPropia(data);
        cerrarDialogo();
      });
    });
  });

  var guardada = leerGuardada();
  if (guardada) {
    mostrarPropia(guardada);
  } else {
    pintarEstrellas(estrellasValor);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gardenclaw-modular-hero-oferta"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-carrusel]').forEach(function (root) {
  var viewport = root.querySelector('[data-carrusel-viewport]');
  var slides = Array.prototype.slice.call(root.querySelectorAll('[data-carrusel-slide]'));
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-carrusel-thumb]'));
  var dots = Array.prototype.slice.call(root.querySelectorAll('[data-carrusel-dot]'));
  var prevBtn = root.querySelector('[data-carrusel-prev]');
  var nextBtn = root.querySelector('[data-carrusel-next]');
  if (!viewport || slides.length === 0) return;
  var index = 0;
  var viewportWidth = viewport.getBoundingClientRect().width;

  function positionSlides(deltaPx, withTransition) {
    slides.forEach(function (s, si) {
      var base = (si - index) * viewportWidth;
      s.style.transition = withTransition ? 'transform 0.32s ease' : 'none';
      s.style.transform = 'translateX(' + (base + deltaPx) + 'px)';
    });
  }

  function goTo(i) {
    index = (i + slides.length) % slides.length;
    positionSlides(0, true);
    slides.forEach(function (s, si) {
      if (si === index) {
        s.setAttribute('data-active', '');
      } else {
        s.removeAttribute('data-active');
      }
    });
    thumbs.forEach(function (t, ti) {
      if (ti === index) {
        t.setAttribute('data-active', '');
      } else {
        t.removeAttribute('data-active');
      }
    });
    dots.forEach(function (d, di) {
      if (di === index) {
        d.setAttribute('data-active', '');
      } else {
        d.removeAttribute('data-active');
      }
    });
  }

  if (prevBtn) prevBtn.addEventListener('click', function () { goTo(index - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { goTo(index + 1); });
  thumbs.forEach(function (t, ti) {
    t.addEventListener('click', function () { goTo(ti); });
  });
  dots.forEach(function (d, di) {
    d.addEventListener('click', function () { goTo(di); });
  });

  var dragStartX = null;
  var dragDeltaX = 0;

  viewport.addEventListener('touchstart', function (e) {
    dragStartX = e.touches[0].clientX;
    dragDeltaX = 0;
    viewportWidth = viewport.getBoundingClientRect().width;
  }, { passive: true });

  viewport.addEventListener('touchmove', function (e) {
    if (dragStartX === null) return;
    dragDeltaX = e.touches[0].clientX - dragStartX;
    positionSlides(dragDeltaX, false);
  }, { passive: true });

  viewport.addEventListener('touchend', function () {
    if (dragStartX === null) return;
    var threshold = viewportWidth * 0.18;
    if (Math.abs(dragDeltaX) > threshold && slides.length > 1) {
      goTo(index + (dragDeltaX < 0 ? 1 : -1));
    } else {
      positionSlides(0, true);
    }
    dragStartX = null;
    dragDeltaX = 0;
  });

  window.addEventListener('resize', function () {
    viewportWidth = viewport.getBoundingClientRect().width;
    positionSlides(0, false);
  });

  positionSlides(0, false);
});

/* Ajuste automático de tamaño (ESTRUCTURA.md, reglas de Juanes 28-oct-2026). El copy se escribe
   libre y aquí se ajusta: frase hero en 1 renglón y pregunta de dolor en máximo 2, lo más grandes
   posible sin pasar el tamaño del título. Bullets: el más largo termina en el 75 % del ancho
   (25 % de aire a la derecha) y todos copian ese tamaño. Se recalcula al cargar las fuentes y al
   cambiar el ancho. */
(function () {
  var hero = document.querySelector('.gardenclaw-modular-hero-oferta');
  if (!hero) return;
  var titulo = hero.querySelector('.dsx-h1');
  var tagline = hero.querySelector('.gardenclaw-modular-tagline');
  var pregunta = hero.querySelector('.gardenclaw-modular-pregunta-dolor');
  var bullets = Array.prototype.slice.call(hero.querySelectorAll('.gardenclaw-modular-beneficios li'));
  var MINIMO = 9;

  function mayorQueCabe(el, cabe, maximo) {
    var bajo = MINIMO, alto = maximo, mejor = MINIMO;
    for (var i = 0; i < 14; i++) {
      var medio = (bajo + alto) / 2;
      el.style.fontSize = medio + 'px';
      if (cabe(el)) { mejor = medio; bajo = medio; } else { alto = medio; }
    }
    return Math.floor(mejor * 4) / 4;
  }
  var AIRE_BULLETS = 0.25;
  function unRenglon(el) {
    return el.scrollWidth <= el.clientWidth + 1;
  }
  function bulletConAire(li) {
    var disponible = li.parentElement.clientWidth * (1 - AIRE_BULLETS);
    return unRenglon(li) && li.getBoundingClientRect().width <= disponible;
  }
  function dosRenglones(el) {
    el.style.webkitLineClamp = 'unset';
    var cabe = el.scrollHeight <= parseFloat(getComputedStyle(el).fontSize) * 1.5 * 2 + 2;
    el.style.webkitLineClamp = '';
    return cabe;
  }
  function ajustar() {
    var tope = titulo ? parseFloat(getComputedStyle(titulo).fontSize) : 23;
    if (tagline) tagline.style.fontSize = mayorQueCabe(tagline, unRenglon, tope - 1) + 'px';
    if (pregunta) pregunta.style.fontSize = mayorQueCabe(pregunta, dosRenglones, tope - 3) + 'px';
    if (bullets.length) {
      var comun = Math.min.apply(null, bullets.map(function (li) { return mayorQueCabe(li, bulletConAire, 18); }));
      bullets.forEach(function (li) { li.style.fontSize = comun + 'px'; });
    }
  }

  ajustar();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(ajustar);
  var ancho = window.innerWidth;
  var espera;
  window.addEventListener('resize', function () {
    if (window.innerWidth === ancho) return;
    ancho = window.innerWidth;
    clearTimeout(espera);
    espera = setTimeout(ajustar, 150);
  });
})();

/* Estrellas → reseñas con desplazamiento suave, SIN poner "#resenas" en la dirección
   (si quedaba en la dirección, al reabrir el link la página saltaba sola a las reseñas). */
document.querySelectorAll('[data-ir-resenas], [data-ir-seccion]').forEach(function (enlace) {
  enlace.addEventListener('click', function (e) {
    var destino = document.getElementById(enlace.getAttribute('data-ir-seccion') || 'resenas');
    if (!destino) return;
    e.preventDefault();
    var y = destino.getBoundingClientRect().top + window.pageYOffset;
    var desde = window.pageYOffset;
    window.scrollTo({ top: y, behavior: 'smooth' });
    // Respaldo: si el navegador no anima (pestaña en segundo plano, ahorro de batería), salta directo.
    setTimeout(function () {
      if (Math.abs(window.pageYOffset - desde) < 5) window.scrollTo(0, y);
    }, 700);
  });
});

/* Botón de compra → formulario contra entrega de Releasit (ESTRUCTURA.md, "Conexión con Releasit").
   Esta plantilla no tiene formulario de producto, así que Releasit no inserta su botón: el único
   que crea queda oculto dentro de su botón flotante (desactivado). Nuestro botón dispara ese botón
   oculto, que es el que abre el formulario. Si Releasit todavía no cargó, se espera hasta 3 s; si no
   está (desinstalado o caído), se usa el enlace de carrito de Shopify para no perder la venta. */
(function () {
  var principal = document.querySelector('.gardenclaw-modular-btn-buy');
  if (!principal) return;
  function botonReleasit() {
    return document.getElementById('_rsi-buy-now-button') || document.querySelector('._rsi-buy-now-button');
  }
  principal.addEventListener('click', function () {
    var inicio = Date.now();
    (function intentar() {
      var rsi = botonReleasit();
      if (rsi) { rsi.click(); return; }
      if (Date.now() - inicio < 3000) { setTimeout(intentar, 150); return; }
      var variante = principal.getAttribute('data-variante');
      if (variante) window.location.href = '/cart/' + variante + ':1';
    })();
  });
})();

/* Botón de compra fijo: aparece cuando el botón principal ya quedó arriba, fuera de la pantalla,
   y se esconde cuando el cliente vuelve a verlo. Tocarlo es tocar el botón principal. */
(function () {
  var principal = document.querySelector('.gardenclaw-modular-btn-buy');
  var barra = document.querySelector('[data-sticky-cta]');
  if (!principal || !barra || !('IntersectionObserver' in window)) return;
  var boton = barra.querySelector('button');
  boton.addEventListener('click', function () { principal.click(); });
  new IntersectionObserver(function (entradas) {
    var e = entradas[0];
    var mostrar = !e.isIntersecting && e.boundingClientRect.top < 0;
    // En la vista previa de Shopify su barra inferior tapa el botón; se sube encima de ella.
    // Los clientes no tienen esa barra, así que para ellos no cambia nada.
    var barraPreview = document.getElementById('PBarNextFrameWrapper');
    barra.style.bottom = barraPreview ? barraPreview.getBoundingClientRect().height + 'px' : '';
    barra.classList.toggle('is-visible', mostrar);
    barra.setAttribute('aria-hidden', mostrar ? 'false' : 'true');
    boton.tabIndex = mostrar ? 0 : -1;
  }).observe(principal);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gardenclaw-modular-resenas"] && !Shopify.designMode) return;
  try {
    
var DSX_CO_DEPARTAMENTOS = {
  "Amazonas": ["Leticia", "Puerto Nariño"],
  "Antioquia": ["Medellín", "Bello", "Itagüí", "Envigado", "Rionegro", "Apartadó"],
  "Arauca": ["Arauca", "Saravena", "Tame"],
  "Atlántico": ["Barranquilla", "Soledad", "Malambo", "Puerto Colombia"],
  "Bogotá D.C.": ["Bogotá"],
  "Bolívar": ["Cartagena", "Magangué", "Turbaco"],
  "Boyacá": ["Tunja", "Duitama", "Sogamoso", "Chiquinquirá"],
  "Caldas": ["Manizales", "La Dorada", "Chinchiná"],
  "Caquetá": ["Florencia", "San Vicente del Caguán"],
  "Casanare": ["Yopal", "Aguazul"],
  "Cauca": ["Popayán", "Santander de Quilichao"],
  "Cesar": ["Valledupar", "Aguachica"],
  "Chocó": ["Quibdó", "Istmina"],
  "Córdoba": ["Montería", "Cereté", "Lorica"],
  "Cundinamarca": ["Soacha", "Zipaquirá", "Chía", "Facatativá", "Girardot"],
  "Guainía": ["Inírida"],
  "Guaviare": ["San José del Guaviare"],
  "Huila": ["Neiva", "Pitalito", "Garzón"],
  "La Guajira": ["Riohacha", "Maicao"],
  "Magdalena": ["Santa Marta", "Ciénaga"],
  "Meta": ["Villavicencio", "Acacías", "Granada"],
  "Nariño": ["Pasto", "Ipiales", "Tumaco"],
  "Norte de Santander": ["Cúcuta", "Ocaña", "Pamplona"],
  "Putumayo": ["Mocoa", "Puerto Asís"],
  "Quindío": ["Armenia", "Calarcá"],
  "Risaralda": ["Pereira", "Dosquebradas", "Santa Rosa de Cabal"],
  "San Andrés y Providencia": ["San Andrés", "Providencia"],
  "Santander": ["Bucaramanga", "Floridablanca", "Girón", "Piedecuesta", "Barrancabermeja"],
  "Sucre": ["Sincelejo", "Corozal"],
  "Tolima": ["Ibagué", "Espinal", "Melgar"],
  "Valle del Cauca": ["Cali", "Palmira", "Buenaventura", "Tuluá", "Buga"],
  "Vaupés": ["Mitú"],
  "Vichada": ["Puerto Carreño"]
};

document.querySelectorAll('[data-resenas-seccion]').forEach(function (seccion) {
  var productId = seccion.getAttribute('data-producto-id') || 'default';
  var storageKey = 'dsx_resena_propia_' + productId;
  var lista = seccion.querySelector('[data-resenas-lista]');
  var abrirBtn = seccion.querySelector('[data-resenas-abrir]');
  var dialog = seccion.querySelector('[data-resenas-dialog]');
  var cerrarBtn = seccion.querySelector('[data-resenas-cerrar]');
  var form = seccion.querySelector('[data-resenas-form]');
  var nombreInput = seccion.querySelector('[data-resenas-nombre]');
  var textoInput = seccion.querySelector('[data-resenas-texto]');
  var avatarInput = seccion.querySelector('[data-resenas-avatar-input]');
  var fotoInput = seccion.querySelector('[data-resenas-foto-input]');
  var avatarBotonTexto = seccion.querySelector('[data-resenas-avatar-boton]');
  var fotoBotonTexto = seccion.querySelector('[data-resenas-foto-boton]');
  var depSelect = seccion.querySelector('[data-resenas-departamento]');
  var ciuSelect = seccion.querySelector('[data-resenas-ciudad]');
  var estrellaBtns = Array.prototype.slice.call(seccion.querySelectorAll('[data-estrella]'));
  var estrellasValor = 5;
  var datosActuales = null;
  var tarjetaInsertada = null;

  function getClass(sufijo) {
    return 'gardenclaw-modular-resenas__' + sufijo;
  }

  function poblarDepartamentos() {
    if (!depSelect) return;
    Object.keys(DSX_CO_DEPARTAMENTOS).sort().forEach(function (dep) {
      var opt = document.createElement('option');
      opt.value = dep;
      opt.textContent = dep;
      depSelect.appendChild(opt);
    });
  }
  function poblarCiudades(dep) {
    if (!ciuSelect) return;
    ciuSelect.innerHTML = '<option value="">Ciudad</option>';
    (DSX_CO_DEPARTAMENTOS[dep] || []).forEach(function (c) {
      var opt = document.createElement('option');
      opt.value = c;
      opt.textContent = c;
      ciuSelect.appendChild(opt);
    });
    ciuSelect.disabled = !dep;
  }
  if (depSelect) {
    poblarDepartamentos();
    depSelect.addEventListener('change', function () {
      poblarCiudades(depSelect.value);
    });
  }

  function cerrarDialogo() {
    if (dialog.close) { dialog.close(); } else { dialog.removeAttribute('open'); }
  }

  function pintarEstrellas(n) {
    estrellaBtns.forEach(function (b) {
      var v = parseInt(b.getAttribute('data-estrella'), 10);
      var svg = b.querySelector('svg');
      if (svg) svg.setAttribute('fill', v <= n ? '#F5A623' : '#E5E7EB');
    });
  }
  estrellaBtns.forEach(function (b) {
    b.addEventListener('click', function () {
      estrellasValor = parseInt(b.getAttribute('data-estrella'), 10);
      pintarEstrellas(estrellasValor);
    });
  });

  if (avatarInput && avatarBotonTexto) {
    avatarInput.addEventListener('change', function () {
      avatarBotonTexto.textContent = avatarInput.files.length ? 'Foto lista ✓' : 'Elegir foto';
    });
  }
  if (fotoInput && fotoBotonTexto) {
    fotoInput.addEventListener('change', function () {
      fotoBotonTexto.textContent = fotoInput.files.length ? 'Foto lista ✓' : 'Elegir foto';
    });
  }

  function leerImagenComoDataURL(file, maxDim, calidad, callback) {
    if (!file) { callback(null); return; }
    var lector = new FileReader();
    lector.onload = function (ev) {
      var img = new Image();
      img.onload = function () {
        var escala = Math.min(1, maxDim / Math.max(img.width, img.height));
        var cw = Math.max(1, Math.round(img.width * escala));
        var ch = Math.max(1, Math.round(img.height * escala));
        var canvas = document.createElement('canvas');
        canvas.width = cw;
        canvas.height = ch;
        var ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, cw, ch);
        try {
          callback(canvas.toDataURL('image/jpeg', calidad));
        } catch (err) {
          callback(null);
        }
      };
      img.onerror = function () { callback(null); };
      img.src = ev.target.result;
    };
    lector.onerror = function () { callback(null); };
    lector.readAsDataURL(file);
  }

  function construirTarjetaPropia(data) {
    var card = document.createElement('div');
    card.setAttribute('class', getClass('card'));

    var estrellasDiv = document.createElement('div');
    estrellasDiv.setAttribute('class', getClass('estrellas'));
    for (var i = 1; i <= 5; i++) {
      var color = i <= data.estrellas ? '#F5A623' : '#E5E7EB';
      estrellasDiv.insertAdjacentHTML('beforeend', '<svg width="16" height="16" viewBox="0 0 24 24" fill="' + color + '" aria-hidden="true"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26"></polygon></svg>');
    }
    card.appendChild(estrellasDiv);

    var autor = document.createElement('div');
    autor.setAttribute('class', getClass('autor'));

    var avatar = document.createElement('span');
    avatar.setAttribute('class', getClass('avatar'));
    if (data.avatar) {
      var avatarImg = document.createElement('img');
      avatarImg.src = data.avatar;
      avatarImg.alt = '';
      avatar.appendChild(avatarImg);
    } else {
      avatar.textContent = (data.nombre || '?').slice(0, 1);
    }
    autor.appendChild(avatar);

    var autorTexto = document.createElement('div');
    autorTexto.setAttribute('class', getClass('autor-texto'));
    var nombreLinea = document.createElement('div');
    nombreLinea.setAttribute('class', getClass('nombre-linea'));
    var nombreSpan = document.createElement('span');
    nombreSpan.setAttribute('class', getClass('nombre'));
    nombreSpan.textContent = data.nombre;
    nombreLinea.appendChild(nombreSpan);

    var pendiente = document.createElement('span');
    pendiente.setAttribute('class', getClass('verificada') + ' ' + getClass('verificada--pendiente'));
    pendiente.innerHTML = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#D97706" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"></polyline></svg>En verificación';
    nombreLinea.appendChild(pendiente);

    autorTexto.appendChild(nombreLinea);

    if (data.ciudad) {
      var ciudadP = document.createElement('p');
      ciudadP.setAttribute('class', getClass('ciudad'));
      ciudadP.textContent = data.ciudad;
      autorTexto.appendChild(ciudadP);
    }

    autor.appendChild(autorTexto);
    card.appendChild(autor);

    var texto = document.createElement('p');
    texto.setAttribute('class', getClass('texto'));
    texto.textContent = data.texto;
    card.appendChild(texto);

    if (data.foto) {
      var fotoImg = document.createElement('img');
      fotoImg.setAttribute('class', getClass('foto-adjunta'));
      fotoImg.src = data.foto;
      fotoImg.alt = '';
      card.appendChild(fotoImg);
    }

    return card;
  }

  function mostrarPropia(data) {
    datosActuales = data;
    if (!lista) return;
    if (!tarjetaInsertada) {
      tarjetaInsertada = construirTarjetaPropia(data);
      lista.insertBefore(tarjetaInsertada, lista.firstChild);
    } else {
      var nueva = construirTarjetaPropia(data);
      tarjetaInsertada.replaceWith(nueva);
      tarjetaInsertada = nueva;
    }
    if (abrirBtn) abrirBtn.textContent = 'Editar tu reseña';
  }

  function leerGuardada() {
    try {
      var raw = window.localStorage.getItem(storageKey);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }
  function guardar(data) {
    try {
      window.localStorage.setItem(storageKey, JSON.stringify(data));
    } catch (e) {}
  }

  if (abrirBtn) {
    abrirBtn.addEventListener('click', function () {
      if (datosActuales) {
        nombreInput.value = datosActuales.nombre;
        textoInput.value = datosActuales.texto;
        estrellasValor = datosActuales.estrellas;
        pintarEstrellas(estrellasValor);
        if (avatarBotonTexto) avatarBotonTexto.textContent = datosActuales.avatar ? 'Foto lista ✓' : 'Elegir foto';
        if (fotoBotonTexto) fotoBotonTexto.textContent = datosActuales.foto ? 'Foto lista ✓' : 'Elegir foto';
        if (depSelect && datosActuales.departamento) {
          depSelect.value = datosActuales.departamento;
          poblarCiudades(datosActuales.departamento);
          if (ciuSelect && datosActuales.ciudad) ciuSelect.value = datosActuales.ciudad;
        }
      }
      if (dialog.showModal) { dialog.showModal(); } else { dialog.setAttribute('open', ''); }
    });
  }
  if (cerrarBtn) cerrarBtn.addEventListener('click', cerrarDialogo);
  dialog.addEventListener('click', function (e) {
    if (e.target === dialog) cerrarDialogo();
  });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var nombre = nombreInput.value.trim();
    var texto = textoInput.value.trim();
    if (!nombre || !texto) return;
    var avatarFile = avatarInput && avatarInput.files && avatarInput.files[0];
    var fotoFile = fotoInput && fotoInput.files && fotoInput.files[0];
    leerImagenComoDataURL(avatarFile, 200, 0.82, function (avatarData) {
      leerImagenComoDataURL(fotoFile, 720, 0.78, function (fotoData) {
        var data = {
          nombre: nombre,
          texto: texto,
          estrellas: estrellasValor,
          departamento: depSelect ? depSelect.value : '',
          ciudad: ciuSelect ? ciuSelect.value : '',
          avatar: avatarData || (datosActuales && datosActuales.avatar) || null,
          foto: fotoData || (datosActuales && datosActuales.foto) || null
        };
        guardar(data);
        mostrarPropia(data);
        cerrarDialogo();
      });
    });
  });

  var guardada = leerGuardada();
  if (guardada) {
    mostrarPropia(guardada);
  } else {
    pintarEstrellas(estrellasValor);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["smartsense-modular-hero-oferta"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-carrusel]').forEach(function (root) {
  var viewport = root.querySelector('[data-carrusel-viewport]');
  var slides = Array.prototype.slice.call(root.querySelectorAll('[data-carrusel-slide]'));
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-carrusel-thumb]'));
  var dots = Array.prototype.slice.call(root.querySelectorAll('[data-carrusel-dot]'));
  var prevBtn = root.querySelector('[data-carrusel-prev]');
  var nextBtn = root.querySelector('[data-carrusel-next]');
  if (!viewport || slides.length === 0) return;
  var index = 0;
  var viewportWidth = viewport.getBoundingClientRect().width;

  function positionSlides(deltaPx, withTransition) {
    slides.forEach(function (s, si) {
      var base = (si - index) * viewportWidth;
      s.style.transition = withTransition ? 'transform 0.32s ease' : 'none';
      s.style.transform = 'translateX(' + (base + deltaPx) + 'px)';
    });
  }

  function goTo(i) {
    index = (i + slides.length) % slides.length;
    positionSlides(0, true);
    slides.forEach(function (s, si) {
      if (si === index) {
        s.setAttribute('data-active', '');
      } else {
        s.removeAttribute('data-active');
      }
    });
    thumbs.forEach(function (t, ti) {
      if (ti === index) {
        t.setAttribute('data-active', '');
      } else {
        t.removeAttribute('data-active');
      }
    });
    dots.forEach(function (d, di) {
      if (di === index) {
        d.setAttribute('data-active', '');
      } else {
        d.removeAttribute('data-active');
      }
    });
  }

  if (prevBtn) prevBtn.addEventListener('click', function () { goTo(index - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { goTo(index + 1); });
  thumbs.forEach(function (t, ti) {
    t.addEventListener('click', function () { goTo(ti); });
  });
  dots.forEach(function (d, di) {
    d.addEventListener('click', function () { goTo(di); });
  });

  var dragStartX = null;
  var dragDeltaX = 0;

  viewport.addEventListener('touchstart', function (e) {
    dragStartX = e.touches[0].clientX;
    dragDeltaX = 0;
    viewportWidth = viewport.getBoundingClientRect().width;
  }, { passive: true });

  viewport.addEventListener('touchmove', function (e) {
    if (dragStartX === null) return;
    dragDeltaX = e.touches[0].clientX - dragStartX;
    positionSlides(dragDeltaX, false);
  }, { passive: true });

  viewport.addEventListener('touchend', function () {
    if (dragStartX === null) return;
    var threshold = viewportWidth * 0.18;
    if (Math.abs(dragDeltaX) > threshold && slides.length > 1) {
      goTo(index + (dragDeltaX < 0 ? 1 : -1));
    } else {
      positionSlides(0, true);
    }
    dragStartX = null;
    dragDeltaX = 0;
  });

  window.addEventListener('resize', function () {
    viewportWidth = viewport.getBoundingClientRect().width;
    positionSlides(0, false);
  });

  positionSlides(0, false);
});

/* Ajuste automático de tamaño (ESTRUCTURA.md, reglas de Juanes 28-oct-2026). El copy se escribe
   libre y aquí se ajusta: frase hero en 1 renglón y pregunta de dolor en máximo 2, lo más grandes
   posible sin pasar el tamaño del título. Bullets: el más largo termina en el 75 % del ancho
   (25 % de aire a la derecha) y todos copian ese tamaño. Se recalcula al cargar las fuentes y al
   cambiar el ancho. */
(function () {
  var hero = document.querySelector('.smartsense-modular-hero-oferta');
  if (!hero) return;
  var titulo = hero.querySelector('.dsx-h1');
  var tagline = hero.querySelector('.smartsense-modular-tagline');
  var pregunta = hero.querySelector('.smartsense-modular-pregunta-dolor');
  var bullets = Array.prototype.slice.call(hero.querySelectorAll('.smartsense-modular-beneficios li'));
  var MINIMO = 9;

  function mayorQueCabe(el, cabe, maximo) {
    var bajo = MINIMO, alto = maximo, mejor = MINIMO;
    for (var i = 0; i < 14; i++) {
      var medio = (bajo + alto) / 2;
      el.style.fontSize = medio + 'px';
      if (cabe(el)) { mejor = medio; bajo = medio; } else { alto = medio; }
    }
    return Math.floor(mejor * 4) / 4;
  }
  var AIRE_BULLETS = 0.25;
  function unRenglon(el) {
    return el.scrollWidth <= el.clientWidth + 1;
  }
  function bulletConAire(li) {
    var disponible = li.parentElement.clientWidth * (1 - AIRE_BULLETS);
    return unRenglon(li) && li.getBoundingClientRect().width <= disponible;
  }
  function dosRenglones(el) {
    el.style.webkitLineClamp = 'unset';
    var cabe = el.scrollHeight <= parseFloat(getComputedStyle(el).fontSize) * 1.5 * 2 + 2;
    el.style.webkitLineClamp = '';
    return cabe;
  }
  function ajustar() {
    var tope = titulo ? parseFloat(getComputedStyle(titulo).fontSize) : 23;
    if (tagline) tagline.style.fontSize = mayorQueCabe(tagline, unRenglon, tope - 1) + 'px';
    if (pregunta) pregunta.style.fontSize = mayorQueCabe(pregunta, dosRenglones, tope - 3) + 'px';
    if (bullets.length) {
      var comun = Math.min.apply(null, bullets.map(function (li) { return mayorQueCabe(li, bulletConAire, 18); }));
      bullets.forEach(function (li) { li.style.fontSize = comun + 'px'; });
    }
  }

  ajustar();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(ajustar);
  var ancho = window.innerWidth;
  var espera;
  window.addEventListener('resize', function () {
    if (window.innerWidth === ancho) return;
    ancho = window.innerWidth;
    clearTimeout(espera);
    espera = setTimeout(ajustar, 150);
  });
})();

/* Estrellas → reseñas con desplazamiento suave, SIN poner "#resenas" en la dirección
   (si quedaba en la dirección, al reabrir el link la página saltaba sola a las reseñas). */
document.querySelectorAll('[data-ir-resenas], [data-ir-seccion]').forEach(function (enlace) {
  enlace.addEventListener('click', function (e) {
    var destino = document.getElementById(enlace.getAttribute('data-ir-seccion') || 'resenas');
    if (!destino) return;
    e.preventDefault();
    var y = destino.getBoundingClientRect().top + window.pageYOffset;
    var desde = window.pageYOffset;
    window.scrollTo({ top: y, behavior: 'smooth' });
    // Respaldo: si el navegador no anima (pestaña en segundo plano, ahorro de batería), salta directo.
    setTimeout(function () {
      if (Math.abs(window.pageYOffset - desde) < 5) window.scrollTo(0, y);
    }, 700);
  });
});

/* Botón de compra → formulario contra entrega de Releasit (ESTRUCTURA.md, "Conexión con Releasit").
   Esta plantilla no tiene formulario de producto, así que Releasit no inserta su botón: el único
   que crea queda oculto dentro de su botón flotante (desactivado). Nuestro botón dispara ese botón
   oculto, que es el que abre el formulario. Si Releasit todavía no cargó, se espera hasta 3 s; si no
   está (desinstalado o caído), se usa el enlace de carrito de Shopify para no perder la venta. */
(function () {
  var principal = document.querySelector('.smartsense-modular-btn-buy');
  if (!principal) return;
  function botonReleasit() {
    return document.getElementById('_rsi-buy-now-button') || document.querySelector('._rsi-buy-now-button');
  }
  principal.addEventListener('click', function () {
    var inicio = Date.now();
    (function intentar() {
      var rsi = botonReleasit();
      if (rsi) { rsi.click(); return; }
      if (Date.now() - inicio < 3000) { setTimeout(intentar, 150); return; }
      var variante = principal.getAttribute('data-variante');
      if (variante) window.location.href = '/cart/' + variante + ':1';
    })();
  });
})();

/* Botón de compra fijo: aparece cuando el botón principal ya quedó arriba, fuera de la pantalla,
   y se esconde cuando el cliente vuelve a verlo. Tocarlo es tocar el botón principal. */
(function () {
  var principal = document.querySelector('.smartsense-modular-btn-buy');
  var barra = document.querySelector('[data-sticky-cta]');
  if (!principal || !barra || !('IntersectionObserver' in window)) return;
  var boton = barra.querySelector('button');
  boton.addEventListener('click', function () { principal.click(); });
  new IntersectionObserver(function (entradas) {
    var e = entradas[0];
    var mostrar = !e.isIntersecting && e.boundingClientRect.top < 0;
    // En la vista previa de Shopify su barra inferior tapa el botón; se sube encima de ella.
    // Los clientes no tienen esa barra, así que para ellos no cambia nada.
    var barraPreview = document.getElementById('PBarNextFrameWrapper');
    barra.style.bottom = barraPreview ? barraPreview.getBoundingClientRect().height + 'px' : '';
    barra.classList.toggle('is-visible', mostrar);
    barra.setAttribute('aria-hidden', mostrar ? 'false' : 'true');
    boton.tabIndex = mostrar ? 0 : -1;
  }).observe(principal);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["smartsense-modular-resenas"] && !Shopify.designMode) return;
  try {
    
var DSX_CO_DEPARTAMENTOS = {
  "Amazonas": ["Leticia", "Puerto Nariño"],
  "Antioquia": ["Medellín", "Bello", "Itagüí", "Envigado", "Rionegro", "Apartadó"],
  "Arauca": ["Arauca", "Saravena", "Tame"],
  "Atlántico": ["Barranquilla", "Soledad", "Malambo", "Puerto Colombia"],
  "Bogotá D.C.": ["Bogotá"],
  "Bolívar": ["Cartagena", "Magangué", "Turbaco"],
  "Boyacá": ["Tunja", "Duitama", "Sogamoso", "Chiquinquirá"],
  "Caldas": ["Manizales", "La Dorada", "Chinchiná"],
  "Caquetá": ["Florencia", "San Vicente del Caguán"],
  "Casanare": ["Yopal", "Aguazul"],
  "Cauca": ["Popayán", "Santander de Quilichao"],
  "Cesar": ["Valledupar", "Aguachica"],
  "Chocó": ["Quibdó", "Istmina"],
  "Córdoba": ["Montería", "Cereté", "Lorica"],
  "Cundinamarca": ["Soacha", "Zipaquirá", "Chía", "Facatativá", "Girardot"],
  "Guainía": ["Inírida"],
  "Guaviare": ["San José del Guaviare"],
  "Huila": ["Neiva", "Pitalito", "Garzón"],
  "La Guajira": ["Riohacha", "Maicao"],
  "Magdalena": ["Santa Marta", "Ciénaga"],
  "Meta": ["Villavicencio", "Acacías", "Granada"],
  "Nariño": ["Pasto", "Ipiales", "Tumaco"],
  "Norte de Santander": ["Cúcuta", "Ocaña", "Pamplona"],
  "Putumayo": ["Mocoa", "Puerto Asís"],
  "Quindío": ["Armenia", "Calarcá"],
  "Risaralda": ["Pereira", "Dosquebradas", "Santa Rosa de Cabal"],
  "San Andrés y Providencia": ["San Andrés", "Providencia"],
  "Santander": ["Bucaramanga", "Floridablanca", "Girón", "Piedecuesta", "Barrancabermeja"],
  "Sucre": ["Sincelejo", "Corozal"],
  "Tolima": ["Ibagué", "Espinal", "Melgar"],
  "Valle del Cauca": ["Cali", "Palmira", "Buenaventura", "Tuluá", "Buga"],
  "Vaupés": ["Mitú"],
  "Vichada": ["Puerto Carreño"]
};

document.querySelectorAll('[data-resenas-seccion]').forEach(function (seccion) {
  var productId = seccion.getAttribute('data-producto-id') || 'default';
  var storageKey = 'dsx_resena_propia_' + productId;
  var lista = seccion.querySelector('[data-resenas-lista]');
  var abrirBtn = seccion.querySelector('[data-resenas-abrir]');
  var dialog = seccion.querySelector('[data-resenas-dialog]');
  var cerrarBtn = seccion.querySelector('[data-resenas-cerrar]');
  var form = seccion.querySelector('[data-resenas-form]');
  var nombreInput = seccion.querySelector('[data-resenas-nombre]');
  var textoInput = seccion.querySelector('[data-resenas-texto]');
  var avatarInput = seccion.querySelector('[data-resenas-avatar-input]');
  var fotoInput = seccion.querySelector('[data-resenas-foto-input]');
  var avatarBotonTexto = seccion.querySelector('[data-resenas-avatar-boton]');
  var fotoBotonTexto = seccion.querySelector('[data-resenas-foto-boton]');
  var depSelect = seccion.querySelector('[data-resenas-departamento]');
  var ciuSelect = seccion.querySelector('[data-resenas-ciudad]');
  var estrellaBtns = Array.prototype.slice.call(seccion.querySelectorAll('[data-estrella]'));
  var estrellasValor = 5;
  var datosActuales = null;
  var tarjetaInsertada = null;

  function getClass(sufijo) {
    return 'smartsense-modular-resenas__' + sufijo;
  }

  function poblarDepartamentos() {
    if (!depSelect) return;
    Object.keys(DSX_CO_DEPARTAMENTOS).sort().forEach(function (dep) {
      var opt = document.createElement('option');
      opt.value = dep;
      opt.textContent = dep;
      depSelect.appendChild(opt);
    });
  }
  function poblarCiudades(dep) {
    if (!ciuSelect) return;
    ciuSelect.innerHTML = '<option value="">Ciudad</option>';
    (DSX_CO_DEPARTAMENTOS[dep] || []).forEach(function (c) {
      var opt = document.createElement('option');
      opt.value = c;
      opt.textContent = c;
      ciuSelect.appendChild(opt);
    });
    ciuSelect.disabled = !dep;
  }
  if (depSelect) {
    poblarDepartamentos();
    depSelect.addEventListener('change', function () {
      poblarCiudades(depSelect.value);
    });
  }

  function cerrarDialogo() {
    if (dialog.close) { dialog.close(); } else { dialog.removeAttribute('open'); }
  }

  function pintarEstrellas(n) {
    estrellaBtns.forEach(function (b) {
      var v = parseInt(b.getAttribute('data-estrella'), 10);
      var svg = b.querySelector('svg');
      if (svg) svg.setAttribute('fill', v <= n ? '#F5A623' : '#E5E7EB');
    });
  }
  estrellaBtns.forEach(function (b) {
    b.addEventListener('click', function () {
      estrellasValor = parseInt(b.getAttribute('data-estrella'), 10);
      pintarEstrellas(estrellasValor);
    });
  });

  if (avatarInput && avatarBotonTexto) {
    avatarInput.addEventListener('change', function () {
      avatarBotonTexto.textContent = avatarInput.files.length ? 'Foto lista ✓' : 'Elegir foto';
    });
  }
  if (fotoInput && fotoBotonTexto) {
    fotoInput.addEventListener('change', function () {
      fotoBotonTexto.textContent = fotoInput.files.length ? 'Foto lista ✓' : 'Elegir foto';
    });
  }

  function leerImagenComoDataURL(file, maxDim, calidad, callback) {
    if (!file) { callback(null); return; }
    var lector = new FileReader();
    lector.onload = function (ev) {
      var img = new Image();
      img.onload = function () {
        var escala = Math.min(1, maxDim / Math.max(img.width, img.height));
        var cw = Math.max(1, Math.round(img.width * escala));
        var ch = Math.max(1, Math.round(img.height * escala));
        var canvas = document.createElement('canvas');
        canvas.width = cw;
        canvas.height = ch;
        var ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, cw, ch);
        try {
          callback(canvas.toDataURL('image/jpeg', calidad));
        } catch (err) {
          callback(null);
        }
      };
      img.onerror = function () { callback(null); };
      img.src = ev.target.result;
    };
    lector.onerror = function () { callback(null); };
    lector.readAsDataURL(file);
  }

  function construirTarjetaPropia(data) {
    var card = document.createElement('div');
    card.setAttribute('class', getClass('card'));

    var estrellasDiv = document.createElement('div');
    estrellasDiv.setAttribute('class', getClass('estrellas'));
    for (var i = 1; i <= 5; i++) {
      var color = i <= data.estrellas ? '#F5A623' : '#E5E7EB';
      estrellasDiv.insertAdjacentHTML('beforeend', '<svg width="16" height="16" viewBox="0 0 24 24" fill="' + color + '" aria-hidden="true"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26"></polygon></svg>');
    }
    card.appendChild(estrellasDiv);

    var autor = document.createElement('div');
    autor.setAttribute('class', getClass('autor'));

    var avatar = document.createElement('span');
    avatar.setAttribute('class', getClass('avatar'));
    if (data.avatar) {
      var avatarImg = document.createElement('img');
      avatarImg.src = data.avatar;
      avatarImg.alt = '';
      avatar.appendChild(avatarImg);
    } else {
      avatar.textContent = (data.nombre || '?').slice(0, 1);
    }
    autor.appendChild(avatar);

    var autorTexto = document.createElement('div');
    autorTexto.setAttribute('class', getClass('autor-texto'));
    var nombreLinea = document.createElement('div');
    nombreLinea.setAttribute('class', getClass('nombre-linea'));
    var nombreSpan = document.createElement('span');
    nombreSpan.setAttribute('class', getClass('nombre'));
    nombreSpan.textContent = data.nombre;
    nombreLinea.appendChild(nombreSpan);

    var pendiente = document.createElement('span');
    pendiente.setAttribute('class', getClass('verificada') + ' ' + getClass('verificada--pendiente'));
    pendiente.innerHTML = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#D97706" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"></polyline></svg>En verificación';
    nombreLinea.appendChild(pendiente);

    autorTexto.appendChild(nombreLinea);

    if (data.ciudad) {
      var ciudadP = document.createElement('p');
      ciudadP.setAttribute('class', getClass('ciudad'));
      ciudadP.textContent = data.ciudad;
      autorTexto.appendChild(ciudadP);
    }

    autor.appendChild(autorTexto);
    card.appendChild(autor);

    var texto = document.createElement('p');
    texto.setAttribute('class', getClass('texto'));
    texto.textContent = data.texto;
    card.appendChild(texto);

    if (data.foto) {
      var fotoImg = document.createElement('img');
      fotoImg.setAttribute('class', getClass('foto-adjunta'));
      fotoImg.src = data.foto;
      fotoImg.alt = '';
      card.appendChild(fotoImg);
    }

    return card;
  }

  function mostrarPropia(data) {
    datosActuales = data;
    if (!lista) return;
    if (!tarjetaInsertada) {
      tarjetaInsertada = construirTarjetaPropia(data);
      lista.insertBefore(tarjetaInsertada, lista.firstChild);
    } else {
      var nueva = construirTarjetaPropia(data);
      tarjetaInsertada.replaceWith(nueva);
      tarjetaInsertada = nueva;
    }
    if (abrirBtn) abrirBtn.textContent = 'Editar tu reseña';
  }

  function leerGuardada() {
    try {
      var raw = window.localStorage.getItem(storageKey);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }
  function guardar(data) {
    try {
      window.localStorage.setItem(storageKey, JSON.stringify(data));
    } catch (e) {}
  }

  if (abrirBtn) {
    abrirBtn.addEventListener('click', function () {
      if (datosActuales) {
        nombreInput.value = datosActuales.nombre;
        textoInput.value = datosActuales.texto;
        estrellasValor = datosActuales.estrellas;
        pintarEstrellas(estrellasValor);
        if (avatarBotonTexto) avatarBotonTexto.textContent = datosActuales.avatar ? 'Foto lista ✓' : 'Elegir foto';
        if (fotoBotonTexto) fotoBotonTexto.textContent = datosActuales.foto ? 'Foto lista ✓' : 'Elegir foto';
        if (depSelect && datosActuales.departamento) {
          depSelect.value = datosActuales.departamento;
          poblarCiudades(datosActuales.departamento);
          if (ciuSelect && datosActuales.ciudad) ciuSelect.value = datosActuales.ciudad;
        }
      }
      if (dialog.showModal) { dialog.showModal(); } else { dialog.setAttribute('open', ''); }
    });
  }
  if (cerrarBtn) cerrarBtn.addEventListener('click', cerrarDialogo);
  dialog.addEventListener('click', function (e) {
    if (e.target === dialog) cerrarDialogo();
  });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var nombre = nombreInput.value.trim();
    var texto = textoInput.value.trim();
    if (!nombre || !texto) return;
    var avatarFile = avatarInput && avatarInput.files && avatarInput.files[0];
    var fotoFile = fotoInput && fotoInput.files && fotoInput.files[0];
    leerImagenComoDataURL(avatarFile, 200, 0.82, function (avatarData) {
      leerImagenComoDataURL(fotoFile, 720, 0.78, function (fotoData) {
        var data = {
          nombre: nombre,
          texto: texto,
          estrellas: estrellasValor,
          departamento: depSelect ? depSelect.value : '',
          ciudad: ciuSelect ? ciuSelect.value : '',
          avatar: avatarData || (datosActuales && datosActuales.avatar) || null,
          foto: fotoData || (datosActuales && datosActuales.foto) || null
        };
        guardar(data);
        mostrarPropia(data);
        cerrarDialogo();
      });
    });
  });

  var guardada = leerGuardada();
  if (guardada) {
    mostrarPropia(guardada);
  } else {
    pintarEstrellas(estrellasValor);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["solarmax-modular-hero-oferta"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-carrusel]').forEach(function (root) {
  var viewport = root.querySelector('[data-carrusel-viewport]');
  var slides = Array.prototype.slice.call(root.querySelectorAll('[data-carrusel-slide]'));
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-carrusel-thumb]'));
  var dots = Array.prototype.slice.call(root.querySelectorAll('[data-carrusel-dot]'));
  var prevBtn = root.querySelector('[data-carrusel-prev]');
  var nextBtn = root.querySelector('[data-carrusel-next]');
  if (!viewport || slides.length === 0) return;
  var index = 0;
  var viewportWidth = viewport.getBoundingClientRect().width;

  function positionSlides(deltaPx, withTransition) {
    slides.forEach(function (s, si) {
      var base = (si - index) * viewportWidth;
      s.style.transition = withTransition ? 'transform 0.32s ease' : 'none';
      s.style.transform = 'translateX(' + (base + deltaPx) + 'px)';
    });
  }

  function goTo(i) {
    index = (i + slides.length) % slides.length;
    positionSlides(0, true);
    slides.forEach(function (s, si) {
      if (si === index) {
        s.setAttribute('data-active', '');
      } else {
        s.removeAttribute('data-active');
      }
    });
    thumbs.forEach(function (t, ti) {
      if (ti === index) {
        t.setAttribute('data-active', '');
      } else {
        t.removeAttribute('data-active');
      }
    });
    dots.forEach(function (d, di) {
      if (di === index) {
        d.setAttribute('data-active', '');
      } else {
        d.removeAttribute('data-active');
      }
    });
  }

  if (prevBtn) prevBtn.addEventListener('click', function () { goTo(index - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { goTo(index + 1); });
  thumbs.forEach(function (t, ti) {
    t.addEventListener('click', function () { goTo(ti); });
  });
  dots.forEach(function (d, di) {
    d.addEventListener('click', function () { goTo(di); });
  });

  var dragStartX = null;
  var dragDeltaX = 0;

  viewport.addEventListener('touchstart', function (e) {
    dragStartX = e.touches[0].clientX;
    dragDeltaX = 0;
    viewportWidth = viewport.getBoundingClientRect().width;
  }, { passive: true });

  viewport.addEventListener('touchmove', function (e) {
    if (dragStartX === null) return;
    dragDeltaX = e.touches[0].clientX - dragStartX;
    positionSlides(dragDeltaX, false);
  }, { passive: true });

  viewport.addEventListener('touchend', function () {
    if (dragStartX === null) return;
    var threshold = viewportWidth * 0.18;
    if (Math.abs(dragDeltaX) > threshold && slides.length > 1) {
      goTo(index + (dragDeltaX < 0 ? 1 : -1));
    } else {
      positionSlides(0, true);
    }
    dragStartX = null;
    dragDeltaX = 0;
  });

  window.addEventListener('resize', function () {
    viewportWidth = viewport.getBoundingClientRect().width;
    positionSlides(0, false);
  });

  positionSlides(0, false);
});

/* Ajuste automático de tamaño (ESTRUCTURA.md, reglas de Juanes 28-oct-2026). El copy se escribe
   libre y aquí se ajusta: frase hero en 1 renglón y pregunta de dolor en máximo 2, lo más grandes
   posible sin pasar el tamaño del título. Bullets: el más largo termina en el 75 % del ancho
   (25 % de aire a la derecha) y todos copian ese tamaño. Se recalcula al cargar las fuentes y al
   cambiar el ancho. */
(function () {
  var hero = document.querySelector('.solarmax-modular-hero-oferta');
  if (!hero) return;
  var titulo = hero.querySelector('.dsx-h1');
  var tagline = hero.querySelector('.solarmax-modular-tagline');
  var pregunta = hero.querySelector('.solarmax-modular-pregunta-dolor');
  var bullets = Array.prototype.slice.call(hero.querySelectorAll('.solarmax-modular-beneficios li'));
  var MINIMO = 9;

  function mayorQueCabe(el, cabe, maximo) {
    var bajo = MINIMO, alto = maximo, mejor = MINIMO;
    for (var i = 0; i < 14; i++) {
      var medio = (bajo + alto) / 2;
      el.style.fontSize = medio + 'px';
      if (cabe(el)) { mejor = medio; bajo = medio; } else { alto = medio; }
    }
    return Math.floor(mejor * 4) / 4;
  }
  var AIRE_BULLETS = 0.25;
  function unRenglon(el) {
    return el.scrollWidth <= el.clientWidth + 1;
  }
  function bulletConAire(li) {
    var disponible = li.parentElement.clientWidth * (1 - AIRE_BULLETS);
    return unRenglon(li) && li.getBoundingClientRect().width <= disponible;
  }
  function dosRenglones(el) {
    el.style.webkitLineClamp = 'unset';
    var cabe = el.scrollHeight <= parseFloat(getComputedStyle(el).fontSize) * 1.5 * 2 + 2;
    el.style.webkitLineClamp = '';
    return cabe;
  }
  function ajustar() {
    var tope = titulo ? parseFloat(getComputedStyle(titulo).fontSize) : 23;
    if (tagline) tagline.style.fontSize = mayorQueCabe(tagline, unRenglon, tope - 1) + 'px';
    if (pregunta) pregunta.style.fontSize = mayorQueCabe(pregunta, dosRenglones, tope - 3) + 'px';
    if (bullets.length) {
      var comun = Math.min.apply(null, bullets.map(function (li) { return mayorQueCabe(li, bulletConAire, 18); }));
      bullets.forEach(function (li) { li.style.fontSize = comun + 'px'; });
    }
  }

  ajustar();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(ajustar);
  var ancho = window.innerWidth;
  var espera;
  window.addEventListener('resize', function () {
    if (window.innerWidth === ancho) return;
    ancho = window.innerWidth;
    clearTimeout(espera);
    espera = setTimeout(ajustar, 150);
  });
})();

/* Estrellas → reseñas con desplazamiento suave, SIN poner "#resenas" en la dirección
   (si quedaba en la dirección, al reabrir el link la página saltaba sola a las reseñas). */
document.querySelectorAll('[data-ir-resenas], [data-ir-seccion]').forEach(function (enlace) {
  enlace.addEventListener('click', function (e) {
    var destino = document.getElementById(enlace.getAttribute('data-ir-seccion') || 'resenas');
    if (!destino) return;
    e.preventDefault();
    var y = destino.getBoundingClientRect().top + window.pageYOffset;
    var desde = window.pageYOffset;
    window.scrollTo({ top: y, behavior: 'smooth' });
    // Respaldo: si el navegador no anima (pestaña en segundo plano, ahorro de batería), salta directo.
    setTimeout(function () {
      if (Math.abs(window.pageYOffset - desde) < 5) window.scrollTo(0, y);
    }, 700);
  });
});

/* Botón de compra → formulario contra entrega de Releasit (ESTRUCTURA.md, "Conexión con Releasit").
   Esta plantilla no tiene formulario de producto, así que Releasit no inserta su botón: el único
   que crea queda oculto dentro de su botón flotante (desactivado). Nuestro botón dispara ese botón
   oculto, que es el que abre el formulario. Si Releasit todavía no cargó, se espera hasta 3 s; si no
   está (desinstalado o caído), se usa el enlace de carrito de Shopify para no perder la venta. */
(function () {
  var principal = document.querySelector('.solarmax-modular-btn-buy');
  if (!principal) return;
  function botonReleasit() {
    return document.getElementById('_rsi-buy-now-button') || document.querySelector('._rsi-buy-now-button');
  }
  principal.addEventListener('click', function () {
    var inicio = Date.now();
    (function intentar() {
      var rsi = botonReleasit();
      if (rsi) { rsi.click(); return; }
      if (Date.now() - inicio < 3000) { setTimeout(intentar, 150); return; }
      var variante = principal.getAttribute('data-variante');
      if (variante) window.location.href = '/cart/' + variante + ':1';
    })();
  });
})();

/* Botón de compra fijo: aparece cuando el botón principal ya quedó arriba, fuera de la pantalla,
   y se esconde cuando el cliente vuelve a verlo. Tocarlo es tocar el botón principal. */
(function () {
  var principal = document.querySelector('.solarmax-modular-btn-buy');
  var barra = document.querySelector('[data-sticky-cta]');
  if (!principal || !barra || !('IntersectionObserver' in window)) return;
  var boton = barra.querySelector('button');
  boton.addEventListener('click', function () { principal.click(); });
  new IntersectionObserver(function (entradas) {
    var e = entradas[0];
    var mostrar = !e.isIntersecting && e.boundingClientRect.top < 0;
    // En la vista previa de Shopify su barra inferior tapa el botón; se sube encima de ella.
    // Los clientes no tienen esa barra, así que para ellos no cambia nada.
    var barraPreview = document.getElementById('PBarNextFrameWrapper');
    barra.style.bottom = barraPreview ? barraPreview.getBoundingClientRect().height + 'px' : '';
    barra.classList.toggle('is-visible', mostrar);
    barra.setAttribute('aria-hidden', mostrar ? 'false' : 'true');
    boton.tabIndex = mostrar ? 0 : -1;
  }).observe(principal);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["solarmax-modular-resenas"] && !Shopify.designMode) return;
  try {
    
var DSX_CO_DEPARTAMENTOS = {
  "Amazonas": ["Leticia", "Puerto Nariño"],
  "Antioquia": ["Medellín", "Bello", "Itagüí", "Envigado", "Rionegro", "Apartadó"],
  "Arauca": ["Arauca", "Saravena", "Tame"],
  "Atlántico": ["Barranquilla", "Soledad", "Malambo", "Puerto Colombia"],
  "Bogotá D.C.": ["Bogotá"],
  "Bolívar": ["Cartagena", "Magangué", "Turbaco"],
  "Boyacá": ["Tunja", "Duitama", "Sogamoso", "Chiquinquirá"],
  "Caldas": ["Manizales", "La Dorada", "Chinchiná"],
  "Caquetá": ["Florencia", "San Vicente del Caguán"],
  "Casanare": ["Yopal", "Aguazul"],
  "Cauca": ["Popayán", "Santander de Quilichao"],
  "Cesar": ["Valledupar", "Aguachica"],
  "Chocó": ["Quibdó", "Istmina"],
  "Córdoba": ["Montería", "Cereté", "Lorica"],
  "Cundinamarca": ["Soacha", "Zipaquirá", "Chía", "Facatativá", "Girardot"],
  "Guainía": ["Inírida"],
  "Guaviare": ["San José del Guaviare"],
  "Huila": ["Neiva", "Pitalito", "Garzón"],
  "La Guajira": ["Riohacha", "Maicao"],
  "Magdalena": ["Santa Marta", "Ciénaga"],
  "Meta": ["Villavicencio", "Acacías", "Granada"],
  "Nariño": ["Pasto", "Ipiales", "Tumaco"],
  "Norte de Santander": ["Cúcuta", "Ocaña", "Pamplona"],
  "Putumayo": ["Mocoa", "Puerto Asís"],
  "Quindío": ["Armenia", "Calarcá"],
  "Risaralda": ["Pereira", "Dosquebradas", "Santa Rosa de Cabal"],
  "San Andrés y Providencia": ["San Andrés", "Providencia"],
  "Santander": ["Bucaramanga", "Floridablanca", "Girón", "Piedecuesta", "Barrancabermeja"],
  "Sucre": ["Sincelejo", "Corozal"],
  "Tolima": ["Ibagué", "Espinal", "Melgar"],
  "Valle del Cauca": ["Cali", "Palmira", "Buenaventura", "Tuluá", "Buga"],
  "Vaupés": ["Mitú"],
  "Vichada": ["Puerto Carreño"]
};

document.querySelectorAll('[data-resenas-seccion]').forEach(function (seccion) {
  var productId = seccion.getAttribute('data-producto-id') || 'default';
  var storageKey = 'dsx_resena_propia_' + productId;
  var lista = seccion.querySelector('[data-resenas-lista]');
  var abrirBtn = seccion.querySelector('[data-resenas-abrir]');
  var dialog = seccion.querySelector('[data-resenas-dialog]');
  var cerrarBtn = seccion.querySelector('[data-resenas-cerrar]');
  var form = seccion.querySelector('[data-resenas-form]');
  var nombreInput = seccion.querySelector('[data-resenas-nombre]');
  var textoInput = seccion.querySelector('[data-resenas-texto]');
  var avatarInput = seccion.querySelector('[data-resenas-avatar-input]');
  var fotoInput = seccion.querySelector('[data-resenas-foto-input]');
  var avatarBotonTexto = seccion.querySelector('[data-resenas-avatar-boton]');
  var fotoBotonTexto = seccion.querySelector('[data-resenas-foto-boton]');
  var depSelect = seccion.querySelector('[data-resenas-departamento]');
  var ciuSelect = seccion.querySelector('[data-resenas-ciudad]');
  var estrellaBtns = Array.prototype.slice.call(seccion.querySelectorAll('[data-estrella]'));
  var estrellasValor = 5;
  var datosActuales = null;
  var tarjetaInsertada = null;

  function getClass(sufijo) {
    return 'solarmax-modular-resenas__' + sufijo;
  }

  function poblarDepartamentos() {
    if (!depSelect) return;
    Object.keys(DSX_CO_DEPARTAMENTOS).sort().forEach(function (dep) {
      var opt = document.createElement('option');
      opt.value = dep;
      opt.textContent = dep;
      depSelect.appendChild(opt);
    });
  }
  function poblarCiudades(dep) {
    if (!ciuSelect) return;
    ciuSelect.innerHTML = '<option value="">Ciudad</option>';
    (DSX_CO_DEPARTAMENTOS[dep] || []).forEach(function (c) {
      var opt = document.createElement('option');
      opt.value = c;
      opt.textContent = c;
      ciuSelect.appendChild(opt);
    });
    ciuSelect.disabled = !dep;
  }
  if (depSelect) {
    poblarDepartamentos();
    depSelect.addEventListener('change', function () {
      poblarCiudades(depSelect.value);
    });
  }

  function cerrarDialogo() {
    if (dialog.close) { dialog.close(); } else { dialog.removeAttribute('open'); }
  }

  function pintarEstrellas(n) {
    estrellaBtns.forEach(function (b) {
      var v = parseInt(b.getAttribute('data-estrella'), 10);
      var svg = b.querySelector('svg');
      if (svg) svg.setAttribute('fill', v <= n ? '#F5A623' : '#E5E7EB');
    });
  }
  estrellaBtns.forEach(function (b) {
    b.addEventListener('click', function () {
      estrellasValor = parseInt(b.getAttribute('data-estrella'), 10);
      pintarEstrellas(estrellasValor);
    });
  });

  if (avatarInput && avatarBotonTexto) {
    avatarInput.addEventListener('change', function () {
      avatarBotonTexto.textContent = avatarInput.files.length ? 'Foto lista ✓' : 'Elegir foto';
    });
  }
  if (fotoInput && fotoBotonTexto) {
    fotoInput.addEventListener('change', function () {
      fotoBotonTexto.textContent = fotoInput.files.length ? 'Foto lista ✓' : 'Elegir foto';
    });
  }

  function leerImagenComoDataURL(file, maxDim, calidad, callback) {
    if (!file) { callback(null); return; }
    var lector = new FileReader();
    lector.onload = function (ev) {
      var img = new Image();
      img.onload = function () {
        var escala = Math.min(1, maxDim / Math.max(img.width, img.height));
        var cw = Math.max(1, Math.round(img.width * escala));
        var ch = Math.max(1, Math.round(img.height * escala));
        var canvas = document.createElement('canvas');
        canvas.width = cw;
        canvas.height = ch;
        var ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, cw, ch);
        try {
          callback(canvas.toDataURL('image/jpeg', calidad));
        } catch (err) {
          callback(null);
        }
      };
      img.onerror = function () { callback(null); };
      img.src = ev.target.result;
    };
    lector.onerror = function () { callback(null); };
    lector.readAsDataURL(file);
  }

  function construirTarjetaPropia(data) {
    var card = document.createElement('div');
    card.setAttribute('class', getClass('card'));

    var estrellasDiv = document.createElement('div');
    estrellasDiv.setAttribute('class', getClass('estrellas'));
    for (var i = 1; i <= 5; i++) {
      var color = i <= data.estrellas ? '#F5A623' : '#E5E7EB';
      estrellasDiv.insertAdjacentHTML('beforeend', '<svg width="16" height="16" viewBox="0 0 24 24" fill="' + color + '" aria-hidden="true"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26"></polygon></svg>');
    }
    card.appendChild(estrellasDiv);

    var autor = document.createElement('div');
    autor.setAttribute('class', getClass('autor'));

    var avatar = document.createElement('span');
    avatar.setAttribute('class', getClass('avatar'));
    if (data.avatar) {
      var avatarImg = document.createElement('img');
      avatarImg.src = data.avatar;
      avatarImg.alt = '';
      avatar.appendChild(avatarImg);
    } else {
      avatar.textContent = (data.nombre || '?').slice(0, 1);
    }
    autor.appendChild(avatar);

    var autorTexto = document.createElement('div');
    autorTexto.setAttribute('class', getClass('autor-texto'));
    var nombreLinea = document.createElement('div');
    nombreLinea.setAttribute('class', getClass('nombre-linea'));
    var nombreSpan = document.createElement('span');
    nombreSpan.setAttribute('class', getClass('nombre'));
    nombreSpan.textContent = data.nombre;
    nombreLinea.appendChild(nombreSpan);

    var pendiente = document.createElement('span');
    pendiente.setAttribute('class', getClass('verificada') + ' ' + getClass('verificada--pendiente'));
    pendiente.innerHTML = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#D97706" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"></polyline></svg>En verificación';
    nombreLinea.appendChild(pendiente);

    autorTexto.appendChild(nombreLinea);

    if (data.ciudad) {
      var ciudadP = document.createElement('p');
      ciudadP.setAttribute('class', getClass('ciudad'));
      ciudadP.textContent = data.ciudad;
      autorTexto.appendChild(ciudadP);
    }

    autor.appendChild(autorTexto);
    card.appendChild(autor);

    var texto = document.createElement('p');
    texto.setAttribute('class', getClass('texto'));
    texto.textContent = data.texto;
    card.appendChild(texto);

    if (data.foto) {
      var fotoImg = document.createElement('img');
      fotoImg.setAttribute('class', getClass('foto-adjunta'));
      fotoImg.src = data.foto;
      fotoImg.alt = '';
      card.appendChild(fotoImg);
    }

    return card;
  }

  function mostrarPropia(data) {
    datosActuales = data;
    if (!lista) return;
    if (!tarjetaInsertada) {
      tarjetaInsertada = construirTarjetaPropia(data);
      lista.insertBefore(tarjetaInsertada, lista.firstChild);
    } else {
      var nueva = construirTarjetaPropia(data);
      tarjetaInsertada.replaceWith(nueva);
      tarjetaInsertada = nueva;
    }
    if (abrirBtn) abrirBtn.textContent = 'Editar tu reseña';
  }

  function leerGuardada() {
    try {
      var raw = window.localStorage.getItem(storageKey);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }
  function guardar(data) {
    try {
      window.localStorage.setItem(storageKey, JSON.stringify(data));
    } catch (e) {}
  }

  if (abrirBtn) {
    abrirBtn.addEventListener('click', function () {
      if (datosActuales) {
        nombreInput.value = datosActuales.nombre;
        textoInput.value = datosActuales.texto;
        estrellasValor = datosActuales.estrellas;
        pintarEstrellas(estrellasValor);
        if (avatarBotonTexto) avatarBotonTexto.textContent = datosActuales.avatar ? 'Foto lista ✓' : 'Elegir foto';
        if (fotoBotonTexto) fotoBotonTexto.textContent = datosActuales.foto ? 'Foto lista ✓' : 'Elegir foto';
        if (depSelect && datosActuales.departamento) {
          depSelect.value = datosActuales.departamento;
          poblarCiudades(datosActuales.departamento);
          if (ciuSelect && datosActuales.ciudad) ciuSelect.value = datosActuales.ciudad;
        }
      }
      if (dialog.showModal) { dialog.showModal(); } else { dialog.setAttribute('open', ''); }
    });
  }
  if (cerrarBtn) cerrarBtn.addEventListener('click', cerrarDialogo);
  dialog.addEventListener('click', function (e) {
    if (e.target === dialog) cerrarDialogo();
  });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var nombre = nombreInput.value.trim();
    var texto = textoInput.value.trim();
    if (!nombre || !texto) return;
    var avatarFile = avatarInput && avatarInput.files && avatarInput.files[0];
    var fotoFile = fotoInput && fotoInput.files && fotoInput.files[0];
    leerImagenComoDataURL(avatarFile, 200, 0.82, function (avatarData) {
      leerImagenComoDataURL(fotoFile, 720, 0.78, function (fotoData) {
        var data = {
          nombre: nombre,
          texto: texto,
          estrellas: estrellasValor,
          departamento: depSelect ? depSelect.value : '',
          ciudad: ciuSelect ? ciuSelect.value : '',
          avatar: avatarData || (datosActuales && datosActuales.avatar) || null,
          foto: fotoData || (datosActuales && datosActuales.foto) || null
        };
        guardar(data);
        mostrarPropia(data);
        cerrarDialogo();
      });
    });
  });

  var guardada = leerGuardada();
  if (guardada) {
    mostrarPropia(guardada);
  } else {
    pintarEstrellas(estrellasValor);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wallrepair-modular-hero-oferta"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-carrusel]').forEach(function (root) {
  var viewport = root.querySelector('[data-carrusel-viewport]');
  var slides = Array.prototype.slice.call(root.querySelectorAll('[data-carrusel-slide]'));
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-carrusel-thumb]'));
  var dots = Array.prototype.slice.call(root.querySelectorAll('[data-carrusel-dot]'));
  var prevBtn = root.querySelector('[data-carrusel-prev]');
  var nextBtn = root.querySelector('[data-carrusel-next]');
  if (!viewport || slides.length === 0) return;
  var index = 0;
  var viewportWidth = viewport.getBoundingClientRect().width;

  function positionSlides(deltaPx, withTransition) {
    slides.forEach(function (s, si) {
      var base = (si - index) * viewportWidth;
      s.style.transition = withTransition ? 'transform 0.32s ease' : 'none';
      s.style.transform = 'translateX(' + (base + deltaPx) + 'px)';
    });
  }

  function goTo(i) {
    index = (i + slides.length) % slides.length;
    positionSlides(0, true);
    slides.forEach(function (s, si) {
      if (si === index) {
        s.setAttribute('data-active', '');
      } else {
        s.removeAttribute('data-active');
      }
    });
    thumbs.forEach(function (t, ti) {
      if (ti === index) {
        t.setAttribute('data-active', '');
      } else {
        t.removeAttribute('data-active');
      }
    });
    dots.forEach(function (d, di) {
      if (di === index) {
        d.setAttribute('data-active', '');
      } else {
        d.removeAttribute('data-active');
      }
    });
  }

  if (prevBtn) prevBtn.addEventListener('click', function () { goTo(index - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { goTo(index + 1); });
  thumbs.forEach(function (t, ti) {
    t.addEventListener('click', function () { goTo(ti); });
  });
  dots.forEach(function (d, di) {
    d.addEventListener('click', function () { goTo(di); });
  });

  var dragStartX = null;
  var dragDeltaX = 0;

  viewport.addEventListener('touchstart', function (e) {
    dragStartX = e.touches[0].clientX;
    dragDeltaX = 0;
    viewportWidth = viewport.getBoundingClientRect().width;
  }, { passive: true });

  viewport.addEventListener('touchmove', function (e) {
    if (dragStartX === null) return;
    dragDeltaX = e.touches[0].clientX - dragStartX;
    positionSlides(dragDeltaX, false);
  }, { passive: true });

  viewport.addEventListener('touchend', function () {
    if (dragStartX === null) return;
    var threshold = viewportWidth * 0.18;
    if (Math.abs(dragDeltaX) > threshold && slides.length > 1) {
      goTo(index + (dragDeltaX < 0 ? 1 : -1));
    } else {
      positionSlides(0, true);
    }
    dragStartX = null;
    dragDeltaX = 0;
  });

  window.addEventListener('resize', function () {
    viewportWidth = viewport.getBoundingClientRect().width;
    positionSlides(0, false);
  });

  positionSlides(0, false);
});

/* Ajuste automático de tamaño (ESTRUCTURA.md, reglas de Juanes 28-oct-2026). El copy se escribe
   libre y aquí se ajusta: frase hero en 1 renglón y pregunta de dolor en máximo 2, lo más grandes
   posible sin pasar el tamaño del título. Bullets: el más largo termina en el 75 % del ancho
   (25 % de aire a la derecha) y todos copian ese tamaño. Se recalcula al cargar las fuentes y al
   cambiar el ancho. */
(function () {
  var hero = document.querySelector('.wallrepair-modular-hero-oferta');
  if (!hero) return;
  var titulo = hero.querySelector('.dsx-h1');
  var tagline = hero.querySelector('.wallrepair-modular-tagline');
  var pregunta = hero.querySelector('.wallrepair-modular-pregunta-dolor');
  var bullets = Array.prototype.slice.call(hero.querySelectorAll('.wallrepair-modular-beneficios li'));
  var MINIMO = 9;

  function mayorQueCabe(el, cabe, maximo) {
    var bajo = MINIMO, alto = maximo, mejor = MINIMO;
    for (var i = 0; i < 14; i++) {
      var medio = (bajo + alto) / 2;
      el.style.fontSize = medio + 'px';
      if (cabe(el)) { mejor = medio; bajo = medio; } else { alto = medio; }
    }
    return Math.floor(mejor * 4) / 4;
  }
  var AIRE_BULLETS = 0.25;
  function unRenglon(el) {
    return el.scrollWidth <= el.clientWidth + 1;
  }
  function bulletConAire(li) {
    var disponible = li.parentElement.clientWidth * (1 - AIRE_BULLETS);
    return unRenglon(li) && li.getBoundingClientRect().width <= disponible;
  }
  function dosRenglones(el) {
    el.style.webkitLineClamp = 'unset';
    var cabe = el.scrollHeight <= parseFloat(getComputedStyle(el).fontSize) * 1.5 * 2 + 2;
    el.style.webkitLineClamp = '';
    return cabe;
  }
  function ajustar() {
    var tope = titulo ? parseFloat(getComputedStyle(titulo).fontSize) : 23;
    if (tagline) tagline.style.fontSize = mayorQueCabe(tagline, unRenglon, tope - 1) + 'px';
    if (pregunta) pregunta.style.fontSize = mayorQueCabe(pregunta, dosRenglones, tope - 3) + 'px';
    if (bullets.length) {
      var comun = Math.min.apply(null, bullets.map(function (li) { return mayorQueCabe(li, bulletConAire, 18); }));
      bullets.forEach(function (li) { li.style.fontSize = comun + 'px'; });
    }
  }

  ajustar();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(ajustar);
  var ancho = window.innerWidth;
  var espera;
  window.addEventListener('resize', function () {
    if (window.innerWidth === ancho) return;
    ancho = window.innerWidth;
    clearTimeout(espera);
    espera = setTimeout(ajustar, 150);
  });
})();

/* Estrellas → reseñas con desplazamiento suave, SIN poner "#resenas" en la dirección
   (si quedaba en la dirección, al reabrir el link la página saltaba sola a las reseñas). */
document.querySelectorAll('[data-ir-resenas], [data-ir-seccion]').forEach(function (enlace) {
  enlace.addEventListener('click', function (e) {
    var destino = document.getElementById(enlace.getAttribute('data-ir-seccion') || 'resenas');
    if (!destino) return;
    e.preventDefault();
    var y = destino.getBoundingClientRect().top + window.pageYOffset;
    var desde = window.pageYOffset;
    window.scrollTo({ top: y, behavior: 'smooth' });
    // Respaldo: si el navegador no anima (pestaña en segundo plano, ahorro de batería), salta directo.
    setTimeout(function () {
      if (Math.abs(window.pageYOffset - desde) < 5) window.scrollTo(0, y);
    }, 700);
  });
});

/* Botón de compra → formulario contra entrega de Releasit (ESTRUCTURA.md, "Conexión con Releasit").
   Esta plantilla no tiene formulario de producto, así que Releasit no inserta su botón: el único
   que crea queda oculto dentro de su botón flotante (desactivado). Nuestro botón dispara ese botón
   oculto, que es el que abre el formulario. Si Releasit todavía no cargó, se espera hasta 3 s; si no
   está (desinstalado o caído), se usa el enlace de carrito de Shopify para no perder la venta. */
(function () {
  var principal = document.querySelector('.wallrepair-modular-btn-buy');
  if (!principal) return;
  function botonReleasit() {
    return document.getElementById('_rsi-buy-now-button') || document.querySelector('._rsi-buy-now-button');
  }
  principal.addEventListener('click', function () {
    var inicio = Date.now();
    (function intentar() {
      var rsi = botonReleasit();
      if (rsi) { rsi.click(); return; }
      if (Date.now() - inicio < 3000) { setTimeout(intentar, 150); return; }
      var variante = principal.getAttribute('data-variante');
      if (variante) window.location.href = '/cart/' + variante + ':1';
    })();
  });
})();

/* Botón de compra fijo: aparece cuando el botón principal ya quedó arriba, fuera de la pantalla,
   y se esconde cuando el cliente vuelve a verlo. Tocarlo es tocar el botón principal. */
(function () {
  var principal = document.querySelector('.wallrepair-modular-btn-buy');
  var barra = document.querySelector('[data-sticky-cta]');
  if (!principal || !barra || !('IntersectionObserver' in window)) return;
  var boton = barra.querySelector('button');
  boton.addEventListener('click', function () { principal.click(); });
  new IntersectionObserver(function (entradas) {
    var e = entradas[0];
    var mostrar = !e.isIntersecting && e.boundingClientRect.top < 0;
    // En la vista previa de Shopify su barra inferior tapa el botón; se sube encima de ella.
    // Los clientes no tienen esa barra, así que para ellos no cambia nada.
    var barraPreview = document.getElementById('PBarNextFrameWrapper');
    barra.style.bottom = barraPreview ? barraPreview.getBoundingClientRect().height + 'px' : '';
    barra.classList.toggle('is-visible', mostrar);
    barra.setAttribute('aria-hidden', mostrar ? 'false' : 'true');
    boton.tabIndex = mostrar ? 0 : -1;
  }).observe(principal);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wallrepair-modular-resenas"] && !Shopify.designMode) return;
  try {
    
var DSX_CO_DEPARTAMENTOS = {
  "Amazonas": ["Leticia", "Puerto Nariño"],
  "Antioquia": ["Medellín", "Bello", "Itagüí", "Envigado", "Rionegro", "Apartadó"],
  "Arauca": ["Arauca", "Saravena", "Tame"],
  "Atlántico": ["Barranquilla", "Soledad", "Malambo", "Puerto Colombia"],
  "Bogotá D.C.": ["Bogotá"],
  "Bolívar": ["Cartagena", "Magangué", "Turbaco"],
  "Boyacá": ["Tunja", "Duitama", "Sogamoso", "Chiquinquirá"],
  "Caldas": ["Manizales", "La Dorada", "Chinchiná"],
  "Caquetá": ["Florencia", "San Vicente del Caguán"],
  "Casanare": ["Yopal", "Aguazul"],
  "Cauca": ["Popayán", "Santander de Quilichao"],
  "Cesar": ["Valledupar", "Aguachica"],
  "Chocó": ["Quibdó", "Istmina"],
  "Córdoba": ["Montería", "Cereté", "Lorica"],
  "Cundinamarca": ["Soacha", "Zipaquirá", "Chía", "Facatativá", "Girardot"],
  "Guainía": ["Inírida"],
  "Guaviare": ["San José del Guaviare"],
  "Huila": ["Neiva", "Pitalito", "Garzón"],
  "La Guajira": ["Riohacha", "Maicao"],
  "Magdalena": ["Santa Marta", "Ciénaga"],
  "Meta": ["Villavicencio", "Acacías", "Granada"],
  "Nariño": ["Pasto", "Ipiales", "Tumaco"],
  "Norte de Santander": ["Cúcuta", "Ocaña", "Pamplona"],
  "Putumayo": ["Mocoa", "Puerto Asís"],
  "Quindío": ["Armenia", "Calarcá"],
  "Risaralda": ["Pereira", "Dosquebradas", "Santa Rosa de Cabal"],
  "San Andrés y Providencia": ["San Andrés", "Providencia"],
  "Santander": ["Bucaramanga", "Floridablanca", "Girón", "Piedecuesta", "Barrancabermeja"],
  "Sucre": ["Sincelejo", "Corozal"],
  "Tolima": ["Ibagué", "Espinal", "Melgar"],
  "Valle del Cauca": ["Cali", "Palmira", "Buenaventura", "Tuluá", "Buga"],
  "Vaupés": ["Mitú"],
  "Vichada": ["Puerto Carreño"]
};

document.querySelectorAll('[data-resenas-seccion]').forEach(function (seccion) {
  var productId = seccion.getAttribute('data-producto-id') || 'default';
  var storageKey = 'dsx_resena_propia_' + productId;
  var lista = seccion.querySelector('[data-resenas-lista]');
  var abrirBtn = seccion.querySelector('[data-resenas-abrir]');
  var dialog = seccion.querySelector('[data-resenas-dialog]');
  var cerrarBtn = seccion.querySelector('[data-resenas-cerrar]');
  var form = seccion.querySelector('[data-resenas-form]');
  var nombreInput = seccion.querySelector('[data-resenas-nombre]');
  var textoInput = seccion.querySelector('[data-resenas-texto]');
  var avatarInput = seccion.querySelector('[data-resenas-avatar-input]');
  var fotoInput = seccion.querySelector('[data-resenas-foto-input]');
  var avatarBotonTexto = seccion.querySelector('[data-resenas-avatar-boton]');
  var fotoBotonTexto = seccion.querySelector('[data-resenas-foto-boton]');
  var depSelect = seccion.querySelector('[data-resenas-departamento]');
  var ciuSelect = seccion.querySelector('[data-resenas-ciudad]');
  var estrellaBtns = Array.prototype.slice.call(seccion.querySelectorAll('[data-estrella]'));
  var estrellasValor = 5;
  var datosActuales = null;
  var tarjetaInsertada = null;

  function getClass(sufijo) {
    return 'wallrepair-modular-resenas__' + sufijo;
  }

  function poblarDepartamentos() {
    if (!depSelect) return;
    Object.keys(DSX_CO_DEPARTAMENTOS).sort().forEach(function (dep) {
      var opt = document.createElement('option');
      opt.value = dep;
      opt.textContent = dep;
      depSelect.appendChild(opt);
    });
  }
  function poblarCiudades(dep) {
    if (!ciuSelect) return;
    ciuSelect.innerHTML = '<option value="">Ciudad</option>';
    (DSX_CO_DEPARTAMENTOS[dep] || []).forEach(function (c) {
      var opt = document.createElement('option');
      opt.value = c;
      opt.textContent = c;
      ciuSelect.appendChild(opt);
    });
    ciuSelect.disabled = !dep;
  }
  if (depSelect) {
    poblarDepartamentos();
    depSelect.addEventListener('change', function () {
      poblarCiudades(depSelect.value);
    });
  }

  function cerrarDialogo() {
    if (dialog.close) { dialog.close(); } else { dialog.removeAttribute('open'); }
  }

  function pintarEstrellas(n) {
    estrellaBtns.forEach(function (b) {
      var v = parseInt(b.getAttribute('data-estrella'), 10);
      var svg = b.querySelector('svg');
      if (svg) svg.setAttribute('fill', v <= n ? '#F5A623' : '#E5E7EB');
    });
  }
  estrellaBtns.forEach(function (b) {
    b.addEventListener('click', function () {
      estrellasValor = parseInt(b.getAttribute('data-estrella'), 10);
      pintarEstrellas(estrellasValor);
    });
  });

  if (avatarInput && avatarBotonTexto) {
    avatarInput.addEventListener('change', function () {
      avatarBotonTexto.textContent = avatarInput.files.length ? 'Foto lista ✓' : 'Elegir foto';
    });
  }
  if (fotoInput && fotoBotonTexto) {
    fotoInput.addEventListener('change', function () {
      fotoBotonTexto.textContent = fotoInput.files.length ? 'Foto lista ✓' : 'Elegir foto';
    });
  }

  function leerImagenComoDataURL(file, maxDim, calidad, callback) {
    if (!file) { callback(null); return; }
    var lector = new FileReader();
    lector.onload = function (ev) {
      var img = new Image();
      img.onload = function () {
        var escala = Math.min(1, maxDim / Math.max(img.width, img.height));
        var cw = Math.max(1, Math.round(img.width * escala));
        var ch = Math.max(1, Math.round(img.height * escala));
        var canvas = document.createElement('canvas');
        canvas.width = cw;
        canvas.height = ch;
        var ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, cw, ch);
        try {
          callback(canvas.toDataURL('image/jpeg', calidad));
        } catch (err) {
          callback(null);
        }
      };
      img.onerror = function () { callback(null); };
      img.src = ev.target.result;
    };
    lector.onerror = function () { callback(null); };
    lector.readAsDataURL(file);
  }

  function construirTarjetaPropia(data) {
    var card = document.createElement('div');
    card.setAttribute('class', getClass('card'));

    var estrellasDiv = document.createElement('div');
    estrellasDiv.setAttribute('class', getClass('estrellas'));
    for (var i = 1; i <= 5; i++) {
      var color = i <= data.estrellas ? '#F5A623' : '#E5E7EB';
      estrellasDiv.insertAdjacentHTML('beforeend', '<svg width="16" height="16" viewBox="0 0 24 24" fill="' + color + '" aria-hidden="true"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26"></polygon></svg>');
    }
    card.appendChild(estrellasDiv);

    var autor = document.createElement('div');
    autor.setAttribute('class', getClass('autor'));

    var avatar = document.createElement('span');
    avatar.setAttribute('class', getClass('avatar'));
    if (data.avatar) {
      var avatarImg = document.createElement('img');
      avatarImg.src = data.avatar;
      avatarImg.alt = '';
      avatar.appendChild(avatarImg);
    } else {
      avatar.textContent = (data.nombre || '?').slice(0, 1);
    }
    autor.appendChild(avatar);

    var autorTexto = document.createElement('div');
    autorTexto.setAttribute('class', getClass('autor-texto'));
    var nombreLinea = document.createElement('div');
    nombreLinea.setAttribute('class', getClass('nombre-linea'));
    var nombreSpan = document.createElement('span');
    nombreSpan.setAttribute('class', getClass('nombre'));
    nombreSpan.textContent = data.nombre;
    nombreLinea.appendChild(nombreSpan);

    var pendiente = document.createElement('span');
    pendiente.setAttribute('class', getClass('verificada') + ' ' + getClass('verificada--pendiente'));
    pendiente.innerHTML = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#D97706" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"></polyline></svg>En verificación';
    nombreLinea.appendChild(pendiente);

    autorTexto.appendChild(nombreLinea);

    if (data.ciudad) {
      var ciudadP = document.createElement('p');
      ciudadP.setAttribute('class', getClass('ciudad'));
      ciudadP.textContent = data.ciudad;
      autorTexto.appendChild(ciudadP);
    }

    autor.appendChild(autorTexto);
    card.appendChild(autor);

    var texto = document.createElement('p');
    texto.setAttribute('class', getClass('texto'));
    texto.textContent = data.texto;
    card.appendChild(texto);

    if (data.foto) {
      var fotoImg = document.createElement('img');
      fotoImg.setAttribute('class', getClass('foto-adjunta'));
      fotoImg.src = data.foto;
      fotoImg.alt = '';
      card.appendChild(fotoImg);
    }

    return card;
  }

  function mostrarPropia(data) {
    datosActuales = data;
    if (!lista) return;
    if (!tarjetaInsertada) {
      tarjetaInsertada = construirTarjetaPropia(data);
      lista.insertBefore(tarjetaInsertada, lista.firstChild);
    } else {
      var nueva = construirTarjetaPropia(data);
      tarjetaInsertada.replaceWith(nueva);
      tarjetaInsertada = nueva;
    }
    if (abrirBtn) abrirBtn.textContent = 'Editar tu reseña';
  }

  function leerGuardada() {
    try {
      var raw = window.localStorage.getItem(storageKey);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }
  function guardar(data) {
    try {
      window.localStorage.setItem(storageKey, JSON.stringify(data));
    } catch (e) {}
  }

  if (abrirBtn) {
    abrirBtn.addEventListener('click', function () {
      if (datosActuales) {
        nombreInput.value = datosActuales.nombre;
        textoInput.value = datosActuales.texto;
        estrellasValor = datosActuales.estrellas;
        pintarEstrellas(estrellasValor);
        if (avatarBotonTexto) avatarBotonTexto.textContent = datosActuales.avatar ? 'Foto lista ✓' : 'Elegir foto';
        if (fotoBotonTexto) fotoBotonTexto.textContent = datosActuales.foto ? 'Foto lista ✓' : 'Elegir foto';
        if (depSelect && datosActuales.departamento) {
          depSelect.value = datosActuales.departamento;
          poblarCiudades(datosActuales.departamento);
          if (ciuSelect && datosActuales.ciudad) ciuSelect.value = datosActuales.ciudad;
        }
      }
      if (dialog.showModal) { dialog.showModal(); } else { dialog.setAttribute('open', ''); }
    });
  }
  if (cerrarBtn) cerrarBtn.addEventListener('click', cerrarDialogo);
  dialog.addEventListener('click', function (e) {
    if (e.target === dialog) cerrarDialogo();
  });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var nombre = nombreInput.value.trim();
    var texto = textoInput.value.trim();
    if (!nombre || !texto) return;
    var avatarFile = avatarInput && avatarInput.files && avatarInput.files[0];
    var fotoFile = fotoInput && fotoInput.files && fotoInput.files[0];
    leerImagenComoDataURL(avatarFile, 200, 0.82, function (avatarData) {
      leerImagenComoDataURL(fotoFile, 720, 0.78, function (fotoData) {
        var data = {
          nombre: nombre,
          texto: texto,
          estrellas: estrellasValor,
          departamento: depSelect ? depSelect.value : '',
          ciudad: ciuSelect ? ciuSelect.value : '',
          avatar: avatarData || (datosActuales && datosActuales.avatar) || null,
          foto: fotoData || (datosActuales && datosActuales.foto) || null
        };
        guardar(data);
        mostrarPropia(data);
        cerrarDialogo();
      });
    });
  });

  var guardada = leerGuardada();
  if (guardada) {
    mostrarPropia(guardada);
  } else {
    pintarEstrellas(estrellasValor);
  }
});

  } catch(e) { console.error(e); }
})();
})();
